import React, { useEffect, useState, useMemo } from 'react';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { LoadingButton } from '@mui/lab';
import {InputLabel,Box, FormControl, Select, MenuItem, FormHelperText, Container, Breadcrumbs, Link} from '@mui/material';
import {
  CardContent,
  Card,
  Stack,
  Button,
  Typography,
  Grid,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Dialog, DialogTitle, DialogContent, CircularProgress
} from '@mui/material';
import { IconButton } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import CloseIcon from '@mui/icons-material/Close';

import { getClientContact, setClientContacts, postClientContacts, deleteClientContacts } from 'src/api/clientDetails';
import client from 'src/api/clients';
import { tr } from 'date-fns/locale';
import { lowerCase } from 'lodash';
import { getClientInfo } from 'src/api/groups';
import { getClientList } from 'src/api/analytics';
import { getClientProperties } from 'src/api/ShiftMaster';
import Scrollbar from 'src/components/Scrollbar';
import Page from 'src/components/Page';
import DashboardBreadcrumbLink from 'src/components/DashboardBreadcrumbLink';

const EmailReports = ({isReseller}) => {
  const resellerClientType = (localStorage.getItem('client_type') || '').toUpperCase();
  const effectiveResellerClientType = resellerClientType === 'INDIA' ? 'INDIA' : 'US';
  const [emails, setEmails] = useState('');
  const [highEmails, setHighEmails] = useState('');
  const [contactNumber, setContactNumber] = useState('');
  const [editClientName, setEditedClientName] = useState('');
  const [clientsContactDetails, setClientContactData] = useState([]);

  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editedClient, setEditedClient] = useState(null);

  const [emailErrorMessage, setEmailErrorMessage] = useState(null);
  const [highErrorMessage, setHighErrorMessage] = useState(null);
  const [mobileErrorMessage, setMobileErrorMessage] = useState(null);

  const [emailEditError, setEmailEditError] = useState(null);
  const [mobileEditError, setMobileEditError] = useState(null);

  const [isDataEdited, setIsDataEdited] = useState(false)

  const [display, setDisplay] = useState(false)
  const [message, setMessage] = useState('')

  const [clientId, setClientId] = useState('')
  const [emailHighValidate, setemailHighValidate] = useState('')
  const [emailNormalValidate, setNormalValidate] = useState('')
  const [emailCameraValidate, setEmailCameraValidate] = useState('')

  const [lowEmails, setLowEmails] = useState('')
  const [lowErrorMessage, setLowErrorMessage] = useState('')

  const [cameraDownEmails, setCameraDownEmails] = useState('')
  const [cameraDownErrorMessage, setCameraDownErrorMessage] = useState('')

  const [monthlyClientDashboardEmail, setMonthlyClientDashboardEmail] = useState('')
  const [monthlyClientErrorMessage, setMonthlyClientErrorMessage] = useState('')

  const [invoiceEmail, setInvoiceEmail] = useState('')
  const [invoiceEmailErrorMessage, setInvoiceEmailErrorMessage] = useState('')


  const [loading, showLoading] = useState(false)
  const [noData, setNoData] = useState(false)

  const [clientNameError, setClientNameError] = useState(false);
  const [clientMessage, setClientMessage] = useState('')
  const [addClientType, setAddClientType] = useState('')

  const [setAddTypeClient, setAddSelectedTypeClient] = useState([]);
  const [clientInfo, setClientInfo] = useState([]);
  const [clientData, setClientData] = useState([])

  const [clientType, setClientType] = useState('')

  const [clientTypeerror, setClientTypeError] = useState('')

  const [setTypeClient, setSelectedTypeClient] = useState([]);

  const [checkValue, setCheckValue] = useState(false)
  const [errorClientMessage, setClientErrorMessage] = useState('');
  const [errorClientMessage1, setClientErrorMessage1] = useState('');
  const [submitDisbale, setDisbale] = useState(false);
  const [openAuto, setOpenAuto] = useState(false)

  const [client, setClient] = useState('');
  const [clientLocationOptions, setClientLocationOptions] = useState([]);
  const [selectedClientLocations, setSelectedClientLocations] = useState([]);
  const [locationCheckValue, setLocationCheckValue] = useState(false);
  const [locationErrorMessage, setLocationErrorMessage] = useState('');

  const getEffectiveClientType = () => (isReseller ? effectiveResellerClientType : clientType);
  const getEffectiveAddClientType = () => (isReseller ? effectiveResellerClientType : addClientType);

  const normalizeDisplayName = (name) =>
    String(name || '')
      .trim()
      .replace(/\s+/g, ' ')
      .toLowerCase();

  const buildUniqueClientOptions = (clients) => {
    const grouped = new Map();

    (clients || []).forEach((clientItem) => {
      const key = normalizeDisplayName(clientItem?.displayname);
      if (!key) return;

      if (!grouped.has(key)) {
        grouped.set(key, []);
      }

      grouped.get(key).push(clientItem);
    });

    return Array.from(grouped.values()).map((groupItems) => {
      if (groupItems.length === 1) return groupItems[0];

      const assignTargets = new Set(
        groupItems
          .map((item) => Number(item.AssignClient || 0))
          .filter((assignId) => assignId > 0)
      );

      const mappedMain = groupItems.find((item) => assignTargets.has(Number(item.ID)));
      if (mappedMain) return mappedMain;

      const rootEntry = groupItems.find((item) => Number(item.AssignClient || 0) === 0);
      return rootEntry || groupItems[0];
    });
  };

  const normalizeLocations = (responseData) =>
    Array.from(
      new Map(
        (Array.isArray(responseData) ? responseData : (responseData ? [responseData] : []))
          .map((locationItem) => ({
            ...locationItem,
            ID: Number(locationItem?.ID ?? locationItem?.id ?? 0),
            Location: String(locationItem?.Location || locationItem?.name || '').trim(),
          }))
          .filter((locationItem) => locationItem.ID > 0)
          .map((locationItem) => [locationItem.ID, locationItem])
      ).values()
    );


  useEffect(() => {
    getClientList((response) => {
      if (response.status === 200) {
        setClientInfo(response.data)
      }
    })
  }, [])

  const handleDisplay = () => {
    setDisplay(false)
  }

  const handleClientType = (event) => {
    // console.log("client type",event.target.value)
    setClientType(event.target.value)
    setClientTypeError('')
    setClientLocationOptions([])
    setSelectedClientLocations([])
    setLocationCheckValue(false)
    setLocationErrorMessage('')
  }

  useEffect(() => {
    const effectiveType = getEffectiveClientType();
    if (effectiveType === "INDIA") {
      // console.log("clientType",clientType)
      const indiaClients = clientInfo.filter((row) => row.ClientType === 'INDIA' && row.EnvironmentType !==0);
      const sortedData = [...indiaClients].sort((a, b) =>
        a.displayname.trim().localeCompare(b.displayname.trim())
      )
      setSelectedTypeClient(sortedData)
      //  const indiaClientsSub = subLogin.filter((row) => row.ClientType === 'INDIA');

      //  setSubLoginSelectList(indiaClientsSub)


    }
    else if(effectiveType === "US") {
      const usClients = clientInfo.filter((row) => row.ClientType === 'US' && row.EnvironmentType !==0);
      const sortedData = [...usClients].sort((a, b) =>
        a.displayname.trim().localeCompare(b.displayname.trim())
      )
      setSelectedTypeClient(sortedData)
      //  const usClientsSub = subLogin.filter((row) => row.ClientType === 'US');

      //  setSubLoginSelectList(usClientsSub)


    }

  }, [clientType,clientInfo,isReseller,effectiveResellerClientType])

  useEffect(() => {
    const effectiveAddType = getEffectiveAddClientType();
    if (effectiveAddType === "INDIA") {
      const indiaClients = clientInfo.filter((row) => row.ClientType === 'INDIA');
      setAddSelectedTypeClient(indiaClients)
    }
    else if (effectiveAddType === "US") {
      const usClients = clientInfo.filter((row) => row.ClientType === 'US');
      setAddSelectedTypeClient(usClients)
    }
    else {
      setAddSelectedTypeClient([])
    }

  }, [addClientType, clientInfo, isReseller, effectiveResellerClientType])

  const uniqueClientOptions = useMemo(
    () => buildUniqueClientOptions(setTypeClient || []),
    [setTypeClient]
  );
  const showLocationDropdown = Boolean(client && clientLocationOptions.length > 0);
  const topFieldGrid = {
    xs: 12,
    sm: 6,
    lg: !isReseller && showLocationDropdown ? 4 : 3,
  };
  const contactFieldGrid = {
    xs: 12,
    sm: 6,
    lg: showLocationDropdown ? 4 : 3,
  };
  const topControlSx = {
    '& .MuiOutlinedInput-root': {
      minHeight: 56,
      alignItems: 'center',
    },
  };

  useEffect(() => {
    getClientContact((response) => {
      showLoading(true)
      if (response.status === 200) {
        //   console.log("client contacts",response.data);
        setClientContactData(response.data)

      }
      showLoading(false)
    })
  }, []);


  const checkDuplicates = (emails, highEmails, lowEmails, contactNumbers, currentClientId = null) => {
    let isExisted = { email: false, highEmail: false, lowEmail: false, number: false };


    const emailArray = emails ? emails.split(',').map(email => email.trim().toLowerCase()).filter(email => email) : [];
    const highEmailArray = highEmails ? highEmails.split(',').map(email => email.trim().toLowerCase()).filter(email => email) : [];
    const lowEmailArray = lowEmails ? lowEmails.split(',').map(email => email.trim().toLowerCase()).filter(email => email) : [];
    const contactNumberArray = contactNumbers ? contactNumbers.split(',').map(num => num.trim()).filter(num => num) : [];


    const allInputEmails = [...emailArray, ...highEmailArray, ...lowEmailArray];


    for (const item of clientsContactDetails) {

      if (currentClientId && item.Id === currentClientId) {
        continue;
      }


      const existingEmails = item.ContactEmail
        ? item.ContactEmail.split(',').map(email => email.trim().toLowerCase()).filter(email => email)
        : [];
      const existingHighEmails = item.HighPriorityClientEmails
        ? item.HighPriorityClientEmails.split(',').map(email => email.trim().toLowerCase()).filter(email => email)
        : [];
      const existingLowEmails = item.LowPriorityClientEmails
        ? item.LowPriorityClientEmails.split(',').map(email => email.trim().toLowerCase()).filter(email => email)
        : [];
      const allExistingEmails = [...existingEmails, ...existingHighEmails, ...existingLowEmails];


      for (const email of allInputEmails) {
        if (allExistingEmails.includes(email)) {

          if (emailArray.includes(email)) {
            isExisted.email = true;
          }
          if (highEmailArray.includes(email)) {
            isExisted.highEmail = true;
          }
          if (lowEmailArray.includes(email)) {
            isExisted.lowEmail = true;
          }
        }
      }


      if (item.ContactMobileNo) {
        const existingNumbers = item.ContactMobileNo.split(',')
          .map(num => num.trim())
          .filter(num => num);
        for (const number of contactNumberArray) {
          if (existingNumbers.includes(number)) {
            isExisted.number = true;
            break;
          }
        }
      }


      if (isExisted.email && isExisted.highEmail && isExisted.lowEmail && isExisted.number) {
        break;
      }
    }

    return isExisted;
  };

  const validateEmails = (emailList) => {
    const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    let validEmail = true;

    for (const email of emailList) {
      if (!emailPattern.test(email)) {
        validEmail = false;
        break;
      }
      if (validEmail) {
        const dotsAfterAt = email.split('@')[1].split('.');
        validEmail = dotsAfterAt.length > 2 ? false : true;
      }
    }

    return validEmail;
  };

  const validateMinEmailLength = (value) => {
    if (!value) return true;
    const emailList = value.split(',').map(email => email.trim()).filter(email => email);
    return emailList.every((email) => email.length >= 5);
  };

  const handleAddClientType = (e) => {
    setClientNameError(false)
    setAddClientType(e.target.value)
  }

  const handleSave = () => {
    setEmailErrorMessage(null);
    setMobileErrorMessage(null);
    setHighErrorMessage(null);
    setLowErrorMessage(null);
    setClientNameError(false);
    setClientMessage('');
    setClientErrorMessage('');
    setCameraDownErrorMessage('');
    setLocationErrorMessage('');
    setEmptyFieldErrors({});

    const clientId = parseInt(client, 10);

    if (!clientId) {
      if (!clientType) {
        setClientTypeError('Please Select ClientType');
      }
      setClientErrorMessage('Please Select Client');
      return;
    }

    if (clientLocationOptions.length > 0 && selectedClientLocations.length === 0) {
      setLocationErrorMessage('Please select a location');
      return;
    }

    const mobilePattern = new RegExp(/^\d{10}$/);
    let validMobile = true;
    const mobilesList = contactNumber ? contactNumber.split(',').map(num => num.trim()).filter(num => num) : [];
    for (const mobile of mobilesList) {
      if (!mobilePattern.test(mobile)) {
        validMobile = false;
        break;
      }
    }


    if (emails) {
      const emailList = emails.split(',').map(email => email.trim()).filter(email => email);
      const highEmailList = highEmails ? highEmails.split(',').map(email => email.trim()).filter(email => email) : [];
      const lowEmailList = lowEmails ? lowEmails.split(',').map(email => email.trim()).filter(email => email) : [];
      const cameraDownEmail = cameraDownEmails ? cameraDownEmails.split(',').map(email => email.trim()).filter(email => email) : [];

      // if (!validateEmails(emailList)) {
      //   setEmailErrorMessage('Enter Valid Email');
      //   return;
      // }

      // if (!validateEmails(highEmailList)) {
      //   setHighErrorMessage('Enter Valid High Priority Email');
      //   return;
      // }

      // if (!validateEmails(lowEmailList)) {
      //   setLowErrorMessage('Enter Valid Low Priority Email');
      //   return;
      // }

      // if (!validateEmails(cameraDownEmail)) {
      //   setCameraDownErrorMessage('Enter Valid Camera online/offline Email')
      //   return;
      // }

      // if (monthlyClientDashboardEmail) {
      //   const monthlyEmailList = monthlyClientDashboardEmail.split(',').map(email => email.trim()).filter(email => email);
      //   if (!validateEmails(monthlyEmailList)) {
      //     setMonthlyClientErrorMessage('Enter Valid Monthly Client Dashboard Email');
      //     return;
      //   }
      // }

      // if (invoiceEmail) {
      //   const invoiceEmailList = invoiceEmail.split(',').map(email => email.trim()).filter(email => email);
      //   if (!validateEmails(invoiceEmailList)) {
      //     setInvoiceEmailErrorMessage('Enter Valid Invoice Email');
      //     return;
      //   }
      // }
    }

    if (!validateMinEmailLength(emails)) {
      setEmailErrorMessage('Email must be at least 5 characters');
      return;
    }
    if (!validateMinEmailLength(highEmails)) {
      setHighErrorMessage('Email must be at least 5 characters');
      return;
    }
    if (!validateMinEmailLength(lowEmails)) {
      setLowErrorMessage('Email must be at least 5 characters');
      return;
    }
    if (!validateMinEmailLength(cameraDownEmails)) {
      setCameraDownErrorMessage('Email must be at least 5 characters');
      return;
    }
    if (!validateMinEmailLength(monthlyClientDashboardEmail)) {
      setMonthlyClientErrorMessage('Email must be at least 5 characters');
      return;
    }
    if (!validateMinEmailLength(invoiceEmail)) {
      setInvoiceEmailErrorMessage('Email must be at least 5 characters');
      return;
    }



    const newEmptyErrors = {};
    const recordNewEntryEmpty = (type, value) => {
      const entryIndex = newEntryIndexes[type];
      if (entryIndex === undefined || entryIndex === null) {
        return;
      }
      const entries = getEntries(value);
      const entryValue = entries[entryIndex] ?? '';
      if (entryValue.trim() === '') {
        newEmptyErrors[type] = EMPTY_FIELD_SAVE_MESSAGE;
      }
    };

    recordNewEntryEmpty('email', emails);
    recordNewEntryEmpty('highEmails', highEmails);
    recordNewEntryEmpty('lowEmails', lowEmails);
    recordNewEntryEmpty('cameraDownEmails', cameraDownEmails);
    recordNewEntryEmpty('monthlyClientDashboardEmail', monthlyClientDashboardEmail);
    recordNewEntryEmpty('invoiceEmail', invoiceEmail);
    recordNewEntryEmpty('number', contactNumber);

    if (Object.keys(newEmptyErrors).length > 0) {
      setEmptyFieldErrors(newEmptyErrors);
      return;
    }

    const isExisted = checkDuplicates(emails, highEmails, lowEmails, contactNumber, cameraDownEmails);

    const targetClientIds =
      clientLocationOptions.length > 0
        ? selectedClientLocations
        : [clientId];

    const data = targetClientIds.map((targetClientId) => ({
      ClientId: targetClientId,
      ContactEmail: emails || '',
      ContactMobileNo: contactNumber || '',
      LowPriorityClientEmails: lowEmails || '',
      HighPriorityClientEmails: highEmails || '',
      CameraDownEmails: cameraDownEmails || '',
      MonthlyClientDashboardEmails: monthlyClientDashboardEmail || '',
      //InvoiceEmails: invoiceEmail || ''
    }));

    setClientContacts(data, (response) => {
      if (response.status === 200) {
        handleClear();
        setIsDataEdited(false);
        getClientContact((response) => {
          if (response.status === 200) {
            setClientContactData(response.data);
          }
        });
      }
    });
  };


  const handleClear = () => {
    setEmails('');
    setHighEmails('');
    setLowEmails('');
    setContactNumber('');
    setEmailErrorMessage(null);
    setMobileErrorMessage(null);
    setEditedMail('');
    setEditedNumber('');
    setEditedHighEmail('');
    setEditedNormalEmail('');
    setHighErrorMessage(null);
    setLowErrorMessage(null);
    setClient(null);
    setClientType('');
    setSelectedTypeClient([]);
    setClientLocationOptions([]);
    setSelectedClientLocations([]);
    setLocationCheckValue(false);
    setLocationErrorMessage('');
    setClientErrorMessage('');
    setClientTypeError('');
    setIsDataEdited(false);
    setCameraDownEmails('')
    setEditedCameraDownEmail('')
    setEmailCameraValidate('')
    setMonthlyClientDashboardEmail('');
    setInvoiceEmail('');
    setMonthlyClientErrorMessage('');
    setInvoiceEmailErrorMessage('');
    setEditedMonthlyDashboardEmail('');
    setEditedInvoiceEmail('');
    setEmptyFieldErrors({});
    setEmptyFieldPrompts({});
    setNewEntryIndexes({});
    setEmptyEditFieldErrors({});
    setNewEditEntryIndexes({});
  };

  const [editedmail, setEditedMail] = useState('')
  const [editedNumber, setEditedNumber] = useState('')
  const [editedHighEmail, setEditedHighEmail] = useState('')
  const [editedNormalEmail, setEditedNormalEmail] = useState('')
  const [editedCameraDownEmail, setEditedCameraDownEmail] = useState('')
  const [editedMonthlyDashboardEmail, setEditedMonthlyDashboardEmail] = useState('')
  const [editedInvoiceEmail, setEditedInvoiceEmail] = useState('')

  const handleEdit = (client) => {
    console.log("clinet edit ", client);
    setIsDataEdited(true)
    setEditedClient(client);
    setEditedClientName(client.Name);
    setEditedMail(client.ContactEmail ? client.ContactEmail : '')
    setEditedNumber(client.ContactMobileNo ? client.ContactMobileNo : '')
    setEditedHighEmail(client.HighPriorityClientEmails ? client.HighPriorityClientEmails : '')
    setEditedNormalEmail(client.LowPriorityClientEmails ? client.LowPriorityClientEmails : '')
    setEditedCameraDownEmail(client.CameraDownEmails ? client.CameraDownEmails : '')
    setEditedMonthlyDashboardEmail(client.MonthlyClientDashboardEmails ? client.MonthlyClientDashboardEmails : '');
    //setEditedInvoiceEmail(client.InvoiceEmails ? client.InvoiceEmails : '');
    setEmptyEditFieldErrors({});
    setNewEditEntryIndexes({});
    setEditDialogOpen(true);
  };

  const onClientChange = (event, value) => {
    // console.log(selectedGroup)
    setClientErrorMessage('')
    setClientErrorMessage1('')
    setLocationErrorMessage('')
    //setClientCameras([])
    setOpenAuto(false)
    setClientLocationOptions([]);
    setSelectedClientLocations([]);
    setLocationCheckValue(false);

    if (!value || value.length === 0) {
      setClientData([])
    }
    setCheckValue(false)
    let id = ''
    // setSelectedCameras('')
    // setSelectedGroup(0)


    if (!value) {
      setClient('');
      setClientErrorMessage1('');
    }
    else {
      setClientErrorMessage('')
      id = value.ID
      console.log("sleceted id ", id, clientsContactDetails);

      const match = clientsContactDetails.find(item => item.ClientId === id);

      setClient(id)
      const body = { group_id: 0, client_id: id }
      getClientInfo(body, (response) => {
        setClientData(response.data)
        // console.log(response.data)
      })

      getClientProperties({ AssignClient: String(id) }, (response) => {
        if (response.status === 200) {
          setClientLocationOptions(normalizeLocations(response.data));
        } else {
          setClientLocationOptions([]);
        }
      });

      if (match) {
        console.log(`Found item:`, match);
        setClientErrorMessage1('client has data please go with Edit option');
        setDisbale(true)

      } else {
        console.log(`Id ${id} not found`);
        setClientErrorMessage1('');
        setDisbale(false)
      }

    }
  }

  const handleCloseEditDialog = () => {
    setemailHighValidate('');
    setNormalValidate('');
    setEditDialogOpen(false);
    setEditedClient(null);
    setEmails('');
    setHighEmails('')
    setContactNumber('');
    setEmailErrorMessage(null);
    setMobileErrorMessage(null);
    setIsDataEdited(false)
    setEmailEditError(null)
    setMobileEditError(null)
    setHighErrorMessage(null)
    setLowErrorMessage(null)
    setEmptyEditFieldErrors({});
    setEmptyFieldPrompts({});
    setNewEditEntryIndexes({});
  };

  const handleLocationFilterOptions = (options, params) => {
    const filter = createFilterOptions();
    const filtered = filter(options, params);
    return options.length > 0 ? [{ title: 'Select All', selectall: true }, ...filtered] : filtered;
  };

  const handleLocationChange = (_, value) => {
    let nextSelectedLocations = [];

    if (value.some((obj) => obj.hasOwnProperty('selectall'))) {
      nextSelectedLocations = locationCheckValue
        ? []
        : clientLocationOptions.map((locationItem) => locationItem.ID || locationItem.id);
    } else {
      nextSelectedLocations = value.map((locationItem) => locationItem.ID || locationItem.id);
    }

    setSelectedClientLocations(nextSelectedLocations);
    setLocationCheckValue(
      clientLocationOptions.length > 0 && nextSelectedLocations.length === clientLocationOptions.length
    );
    setLocationErrorMessage('');
  };

  const handleSaveEditDialog = () => {
    setEmailEditError(null);
    setMobileEditError(null);
    setemailHighValidate('');
    setNormalValidate('');
    setEmailCameraValidate('')
    setEmptyEditFieldErrors({});


    const mobilePattern = new RegExp(/^\d{20}$/);
    let validMobile = true;
    const mobilesList = editedNumber ? editedNumber.split(',').map(num => num.trim()).filter(num => num) : [];
    for (const mobile of mobilesList) {
      if (!mobilePattern.test(mobile)) {
        validMobile = false;
        break;
      }
    }


    // if (editedmail) {
    //   const emailList = editedmail.split(',').map(email => email.trim()).filter(email => email);
    //   if (!validateEmails(emailList)) {
    //     setEmailEditError('Enter Valid Email');
    //     // if (!validMobile) {
    //     //   setMobileEditError('Enter Valid Contact Number');
    //     // }
    //     return;
    //   }
    // }

    // if (editedHighEmail) {
    //   const highEmailList = editedHighEmail.split(',').map(email => email.trim()).filter(email => email);
    //   if (!validateEmails(highEmailList)) {
    //     setemailHighValidate('Enter Valid High Priority Email');
    //     return;
    //   }
    // }

    // if (editedNormalEmail) {
    //   const normalEmailList = editedNormalEmail.split(',').map(email => email.trim()).filter(email => email);
    //   if (!validateEmails(normalEmailList)) {
    //     setNormalValidate('Enter Valid Normal Priority Email');
    //     return;
    //   }
    // }

    // if (editedCameraDownEmail) {
    //   const normalEmailList = editedCameraDownEmail.split(',').map(email => email.trim()).filter(email => email);
    //   if (!validateEmails(normalEmailList)) {
    //     emailCameraValidate('Enter Valid Camera online/offline Email');
    //     return;
    //   }
    // }

    // if (editedMonthlyDashboardEmail) {
    //   const monthlyEmailList = editedMonthlyDashboardEmail.split(',').map(email => email.trim()).filter(email => email);
    //   if (!validateEmails(monthlyEmailList)) {
    //     setMonthlyClientErrorMessage('Enter Valid Monthly Client Dashboard Email');
    //     return;
    //   }
    // }

    // if (editedInvoiceEmail) {
    //   const invoiceEmailList = editedInvoiceEmail.split(',').map(email => email.trim()).filter(email => email);
    //   if (!validateEmails(invoiceEmailList)) {
    //     setInvoiceEmailErrorMessage('Enter Valid Invoice Email');
    //     return;
    //   }
    // }

    if (!validateMinEmailLength(editedmail)) {
      setEmailEditError('Email must be at least 5 characters');
      return;
    }
    if (!validateMinEmailLength(editedHighEmail)) {
      setemailHighValidate('Email must be at least 5 characters');
      return;
    }
    if (!validateMinEmailLength(editedNormalEmail)) {
      setNormalValidate('Email must be at least 5 characters');
      return;
    }
    if (!validateMinEmailLength(editedCameraDownEmail)) {
      setEmailCameraValidate('Email must be at least 5 characters');
      return;
    }
    if (!validateMinEmailLength(editedMonthlyDashboardEmail)) {
      setMonthlyClientErrorMessage('Email must be at least 5 characters');
      return;
    }
    if (!validateMinEmailLength(editedInvoiceEmail)) {
      setInvoiceEmailErrorMessage('Email must be at least 5 characters');
      return;
    }

    const newEmptyEditErrors = {};
    const recordNewEditEntryEmpty = (type, value) => {
      const entryIndex = newEditEntryIndexes[type];
      if (entryIndex === undefined || entryIndex === null) {
        return;
      }
      const entries = getEntries(value);
      const entryValue = entries[entryIndex] ?? '';
      if (entryValue.trim() === '') {
        newEmptyEditErrors[type] = EMPTY_FIELD_SAVE_MESSAGE;
      }
    };

    recordNewEditEntryEmpty('email', editedmail);
    recordNewEditEntryEmpty('editedHighEmail', editedHighEmail);
    recordNewEditEntryEmpty('editedNormalEmail', editedNormalEmail);
    recordNewEditEntryEmpty('editedCameraDownEmail', editedCameraDownEmail);
    recordNewEditEntryEmpty('editedMonthlyDashboardEmail', editedMonthlyDashboardEmail);
    recordNewEditEntryEmpty('editedInvoiceEmail', editedInvoiceEmail);
    recordNewEditEntryEmpty('number', editedNumber);

    if (Object.keys(newEmptyEditErrors).length > 0) {
      setEmptyEditFieldErrors(newEmptyEditErrors);
      return;
    }

    const isExisted = checkDuplicates(editedmail, editedHighEmail, editedNormalEmail, editedNumber, editedClient.Id);

    // if (isExisted.email) {
    //   setEmailEditError('Daily emails already exist');
    //   return;
    // }
    // if (isExisted.highEmail) {
    //   setemailHighValidate('High-priority emails already exist');
    //   return;
    // }
    // if (isExisted.lowEmail) {
    //   setNormalValidate('Low-priority emails already exist');
    //   return;
    // }
    // if (isExisted.number) {
    //   setMobileEditError('Contact numbers already exist');
    //   return;
    // }

    const updatedClient = {
      Id: editedClient.Id,
      ContactEmail: editedmail || '',
      ContactMobileNo: editedNumber || '',
      LowPriorityClientEmails: editedNormalEmail || '',
      HighPriorityClientEmails: editedHighEmail || '',
      CameraDownEmails: editedCameraDownEmail || '',
      MonthlyClientDashboardEmails: editedMonthlyDashboardEmail || '',
      //InvoiceEmails: editedInvoiceEmail || ''
    };

    postClientContacts(updatedClient, (response) => {
      if (response.status === 200) {
        getClientContact((response) => {
          if (response.status === 200) {
            setClientContactData(response.data);
            setEmailEditError(null);
            setMobileEditError(null);
            setemailHighValidate('');
            setNormalValidate('');
          }
        });
        handleClear();
        handleCloseEditDialog();
      }
    });
  };


  const handleDelete = (Id) => {
    setDisplay(true)
    setClientId(Id)
  };

  const delContact = () => {

    // console.log("deleted ID", clientId);

    const data = {
      Id: clientId
    }
    deleteClientContacts(data, (response) => {
      if (response.status === 200) {
        // console.log("client contacts",response.data);
        getClientContact((response) => {
          if (response.status === 200) {
            setClientContactData(response.data)
          }
        })
      }
      setDisplay(false)
    })
  }

  const [addEmptyBox, setEmptyBox] = useState([
    {
      email: false,
      number: false,
      highEmails: false,
      lowEmails: false,
      monthlyClientDashboardEmail: false,
      invoiceEmail: false
    }
  ])

  const EMPTY_FIELD_SAVE_MESSAGE = 'Please add data. Empty fields are not supported.';
  const EMPTY_FIELD_PROMPT_MESSAGE = 'Enter data into the existing empty field instead of creating a new entry';

  const [emptyFieldPrompts, setEmptyFieldPrompts] = useState({});
  const [emptyFieldErrors, setEmptyFieldErrors] = useState({});
  const [emptyEditFieldErrors, setEmptyEditFieldErrors] = useState({});

  const [newEntryIndexes, setNewEntryIndexes] = useState({});
  const [newEditEntryIndexes, setNewEditEntryIndexes] = useState({});

  const getFieldValue = (type, isEdit) => {
    if (isEdit) {
      if (type === 'email') return editedmail;
      if (type === 'editedHighEmail') return editedHighEmail;
      if (type === 'editedNormalEmail') return editedNormalEmail;
      if (type === 'editedCameraDownEmail') return editedCameraDownEmail;
      if (type === 'editedMonthlyDashboardEmail') return editedMonthlyDashboardEmail;
      if (type === 'editedInvoiceEmail') return editedInvoiceEmail;
      if (type === 'number') return editedNumber;
      return '';
    }
    if (type === 'email') return emails;
    if (type === 'highEmails') return highEmails;
    if (type === 'lowEmails') return lowEmails;
    if (type === 'cameraDownEmails') return cameraDownEmails;
    if (type === 'monthlyClientDashboardEmail') return monthlyClientDashboardEmail;
    if (type === 'invoiceEmail') return invoiceEmail;
    if (type === 'number') return contactNumber;
    return '';
  };

  const getEntries = (value) => (value === '' ? [''] : value.split(','));

  const hasVisibleEmptyEntry = (value, isEditMode, type) => {
    if (!isEditMode && value === '' && !addEmptyBox[0]?.[type]) {
      return false;
    }
    return getEntries(value).some((entry) => entry.trim() === '');
  };

  const setPromptForType = (type) => {
    setEmptyFieldPrompts((prev) => ({
      ...prev,
      [type]: EMPTY_FIELD_PROMPT_MESSAGE,
    }));
  };

  const clearPromptForType = (type) => {
    setEmptyFieldPrompts((prev) => {
      if (!prev[type]) return prev;
      const next = { ...prev };
      delete next[type];
      return next;
    });
  };

  const setNewEntryIndex = (type, index, isEditMode) => {
    if (isEditMode) {
      setNewEditEntryIndexes((prev) => ({ ...prev, [type]: index }));
    } else {
      setNewEntryIndexes((prev) => ({ ...prev, [type]: index }));
    }
  };

  const clearNewEntryIndex = (type, isEditMode) => {
    if (isEditMode) {
      setNewEditEntryIndexes((prev) => {
        if (prev[type] === undefined) return prev;
        const next = { ...prev };
        delete next[type];
        return next;
      });
    } else {
      setNewEntryIndexes((prev) => {
        if (prev[type] === undefined) return prev;
        const next = { ...prev };
        delete next[type];
        return next;
      });
    }
  };

  const shouldShowPrompt = (type, isEditMode) =>
    Boolean(emptyFieldPrompts[type] && hasVisibleEmptyEntry(getFieldValue(type, isEditMode), isEditMode, type));

  const handleBoxClick = (type) => {
    
    if (type === 'email' || type === 'editedHighEmail' || type === 'editedNormalEmail' || type === 'highEmails' || type === 'lowEmails' || type === 'cameraDownEmails' || type === 'editedCameraDownEmail' || type === 'monthlyClientDashboardEmail' || type === 'editedMonthlyDashboardEmail' || type === 'invoiceEmail' || type === 'editedInvoiceEmail') {

      if (!isDataEdited) {
        const currentValue = getFieldValue(type, false);
        if (hasVisibleEmptyEntry(currentValue, false, type)) {
          setPromptForType(type);
          return;
        }
        if (type === "email") {
          if (!emails) {
            setEmptyBox(prevState => [
              {
                ...prevState[0],
                email: true
              },
              ...prevState.slice(1)
            ]);
            setNewEntryIndex('email', 0, false);
          }
          else if (emails) {
            setEmptyBox(prevState => [
              {
                ...prevState[0],
                email: false
              },
              ...prevState.slice(1)
            ]);

            setEmails(emails + ',')
            setNewEntryIndex('email', getEntries(emails).length, false);
          }
        }
        if (type === "highEmails") {
          if (!highEmails) {
            setEmptyBox(prevState => [
              {
                ...prevState[0],
                highEmails: true
              },
              ...prevState.slice(1)
            ]);
            setNewEntryIndex('highEmails', 0, false);
          }
          else if (highEmails) {
            setEmptyBox(prevState => [
              {
                ...prevState[0],
                highEmails: false
              },
              ...prevState.slice(1)
            ]);

            setHighEmails(highEmails + ',')
            setNewEntryIndex('highEmails', getEntries(highEmails).length, false);
          }
        }
        if (type === "lowEmails") {
          if (!lowEmails) {
            setEmptyBox(prevState => [
              {
                ...prevState[0],
                lowEmails: true
              },
              ...prevState.slice(1)
            ]);
            setNewEntryIndex('lowEmails', 0, false);
          }
          else if (lowEmails) {
            setEmptyBox(prevState => [
              {
                ...prevState[0],
                lowEmails: false
              },
              ...prevState.slice(1)
            ]);

            setLowEmails(lowEmails + ',')
            setNewEntryIndex('lowEmails', getEntries(lowEmails).length, false);
          }
        }
        if (type === "cameraDownEmails") {
          if (!cameraDownEmails) {
            setEmptyBox(prevState => [
              {
                ...prevState[0],
                cameraDownEmails: true
              },
              ...prevState.slice(1)
            ]);
            setNewEntryIndex('cameraDownEmails', 0, false);
          }
          else if (cameraDownEmails) {
            setEmptyBox(prevState => [
              {
                ...prevState[0],
                cameraDownEmails: false
              },
              ...prevState.slice(1)
            ]);

            setCameraDownEmails(cameraDownEmails + ',')
            setNewEntryIndex('cameraDownEmails', getEntries(cameraDownEmails).length, false);
          }
        }
        if (type === "monthlyClientDashboardEmail") {
          if (!monthlyClientDashboardEmail) {
            setEmptyBox(prevState => [
              {
                ...prevState[0],
                monthlyClientDashboardEmail: true
              },
              ...prevState.slice(1)
            ]);
            setNewEntryIndex('monthlyClientDashboardEmail', 0, false);
          } else if (monthlyClientDashboardEmail) {
            setEmptyBox(prevState => [
              {
                ...prevState[0],
                monthlyClientDashboardEmail: false
              },
              ...prevState.slice(1)
            ]);
            setMonthlyClientDashboardEmail(monthlyClientDashboardEmail + ',');
            setNewEntryIndex('monthlyClientDashboardEmail', getEntries(monthlyClientDashboardEmail).length, false);
          }
        }
        if (type === "invoiceEmail") {
          if (!invoiceEmail) {
            setEmptyBox(prevState => [
              {
                ...prevState[0],
                invoiceEmail: true
              },
              ...prevState.slice(1)
            ]);
            setNewEntryIndex('invoiceEmail', 0, false);
          } else if (invoiceEmail) {
            setEmptyBox(prevState => [
              {
                ...prevState[0],
                invoiceEmail: false
              },
              ...prevState.slice(1)
            ]);
            setInvoiceEmail(invoiceEmail + ',');
            setNewEntryIndex('invoiceEmail', getEntries(invoiceEmail).length, false);
          }
        }
      }
      else {
        const currentValue = getFieldValue(type, true);
        if (hasVisibleEmptyEntry(currentValue, true, type)) {
          setPromptForType(type);
          return;
        }
        if (type === 'email') {
          setEditedMail(editedmail + ',')
          setNewEntryIndex('email', getEntries(editedmail).length, true);
        }
        else if (type === 'editedHighEmail') {
          setEditedHighEmail(editedHighEmail + ',')
          setNewEntryIndex('editedHighEmail', getEntries(editedHighEmail).length, true);
        }
        else if (type === 'editedNormalEmail') {
          setEditedNormalEmail(editedNormalEmail + ',')
          setNewEntryIndex('editedNormalEmail', getEntries(editedNormalEmail).length, true);
        }
        else if (type === 'editedCameraDownEmail') {
          setEditedCameraDownEmail(editedCameraDownEmail + ',')
          setNewEntryIndex('editedCameraDownEmail', getEntries(editedCameraDownEmail).length, true);
        }
        else if (type === 'editedMonthlyDashboardEmail') {
          setEditedMonthlyDashboardEmail(editedMonthlyDashboardEmail + ',');
          setNewEntryIndex('editedMonthlyDashboardEmail', getEntries(editedMonthlyDashboardEmail).length, true);
        } else if (type === 'editedInvoiceEmail') {
          setEditedInvoiceEmail(editedInvoiceEmail + ',');
          setNewEntryIndex('editedInvoiceEmail', getEntries(editedInvoiceEmail).length, true);
        }
      }

    }
    else if (type === 'number') {

      if (!isDataEdited) {
        const currentValue = getFieldValue(type, false);
        if (hasVisibleEmptyEntry(currentValue, false, type)) {
          setPromptForType(type);
          return;
        }
        if (!contactNumber) {
          setEmptyBox(prevState => [
            {
              ...prevState[0],
              number: true
            },
            ...prevState.slice(1)
          ]);
          setNewEntryIndex('number', 0, false);
        }
        else if (contactNumber) {
          setEmptyBox(prevState => [
            {
              ...prevState[0],
              number: false
            },
            ...prevState.slice(1)
          ]);

          setContactNumber(contactNumber + ',')
          setNewEntryIndex('number', getEntries(contactNumber).length, false);
        }
      }
      else {
        const currentValue = getFieldValue(type, true);
        if (hasVisibleEmptyEntry(currentValue, true, type)) {
          setPromptForType(type);
          return;
        }
        setEditedNumber(editedNumber + ',')
        setNewEntryIndex('number', getEntries(editedNumber).length, true);
      }
    }
  }

  // const [closeEmail,setCloseEmail]=useState(false)
  // const [closeNumber,setCloseNumber]=useState(false)

  const removeNumber = (e, index, type) => {
    e.stopPropagation()
    if (!isDataEdited) {
      // Main form fields
      if (type === "email") {
        const numbersArray = emails.split(',');
        numbersArray.splice(index, 1);
        const updatedNumbers = numbersArray.join(',');
        setEmails(updatedNumbers);
        if (newEntryIndexes.email !== undefined) {
          if (newEntryIndexes.email === index) {
            clearNewEntryIndex('email', false);
          } else if (newEntryIndexes.email > index) {
            setNewEntryIndex('email', newEntryIndexes.email - 1, false);
          }
        }
      } else if (type === "highEmails") {
        const numbersArray = highEmails.split(',');
        numbersArray.splice(index, 1);
        const updatedNumbers = numbersArray.join(',');
        setHighEmails(updatedNumbers);
        if (newEntryIndexes.highEmails !== undefined) {
          if (newEntryIndexes.highEmails === index) {
            clearNewEntryIndex('highEmails', false);
          } else if (newEntryIndexes.highEmails > index) {
            setNewEntryIndex('highEmails', newEntryIndexes.highEmails - 1, false);
          }
        }
      } else if (type === "lowEmails") {
        const numbersArray = lowEmails.split(',');
        numbersArray.splice(index, 1);
        const updatedNumbers = numbersArray.join(',');
        setLowEmails(updatedNumbers);
        if (newEntryIndexes.lowEmails !== undefined) {
          if (newEntryIndexes.lowEmails === index) {
            clearNewEntryIndex('lowEmails', false);
          } else if (newEntryIndexes.lowEmails > index) {
            setNewEntryIndex('lowEmails', newEntryIndexes.lowEmails - 1, false);
          }
        }
      } else if (type === "cameraDownEmails") {
        const numbersArray = cameraDownEmails.split(',');
        numbersArray.splice(index, 1);
        const updatedNumbers = numbersArray.join(',');
        setCameraDownEmails(updatedNumbers);
        if (newEntryIndexes.cameraDownEmails !== undefined) {
          if (newEntryIndexes.cameraDownEmails === index) {
            clearNewEntryIndex('cameraDownEmails', false);
          } else if (newEntryIndexes.cameraDownEmails > index) {
            setNewEntryIndex('cameraDownEmails', newEntryIndexes.cameraDownEmails - 1, false);
          }
        }
      } else if (type === "monthlyClientDashboardEmail") {
        const numbersArray = monthlyClientDashboardEmail.split(',');
        numbersArray.splice(index, 1);
        const updatedNumbers = numbersArray.join(',');
        setMonthlyClientDashboardEmail(updatedNumbers);
        if (newEntryIndexes.monthlyClientDashboardEmail !== undefined) {
          if (newEntryIndexes.monthlyClientDashboardEmail === index) {
            clearNewEntryIndex('monthlyClientDashboardEmail', false);
          } else if (newEntryIndexes.monthlyClientDashboardEmail > index) {
            setNewEntryIndex('monthlyClientDashboardEmail', newEntryIndexes.monthlyClientDashboardEmail - 1, false);
          }
        }
      } else if (type === "invoiceEmail") {
        const numbersArray = invoiceEmail.split(',');
        numbersArray.splice(index, 1);
        const updatedNumbers = numbersArray.join(',');
        setInvoiceEmail(updatedNumbers);
        if (newEntryIndexes.invoiceEmail !== undefined) {
          if (newEntryIndexes.invoiceEmail === index) {
            clearNewEntryIndex('invoiceEmail', false);
          } else if (newEntryIndexes.invoiceEmail > index) {
            setNewEntryIndex('invoiceEmail', newEntryIndexes.invoiceEmail - 1, false);
          }
        }
      }
      clearPromptForType(type);
      setEmptyFieldErrors((prev) => {
        if (!prev[type]) return prev;
        const next = { ...prev };
        delete next[type];
        return next;
      });
    } else {
      // Edit dialog fields
      if (type === 'email') {
        const numbersArray = editedmail.split(',');
        numbersArray.splice(index, 1);
        const updatedNumbers = numbersArray.join(',');
        setEditedMail(updatedNumbers);
        if (newEditEntryIndexes.email !== undefined) {
          if (newEditEntryIndexes.email === index) {
            clearNewEntryIndex('email', true);
          } else if (newEditEntryIndexes.email > index) {
            setNewEntryIndex('email', newEditEntryIndexes.email - 1, true);
          }
        }
      } else if (type === 'editedHighEmail') {
        const numbersArray = editedHighEmail.split(',');
        numbersArray.splice(index, 1);
        const updatedNumbers = numbersArray.join(',');
        setEditedHighEmail(updatedNumbers);
        if (newEditEntryIndexes.editedHighEmail !== undefined) {
          if (newEditEntryIndexes.editedHighEmail === index) {
            clearNewEntryIndex('editedHighEmail', true);
          } else if (newEditEntryIndexes.editedHighEmail > index) {
            setNewEntryIndex('editedHighEmail', newEditEntryIndexes.editedHighEmail - 1, true);
          }
        }
      } else if (type === 'editedNormalEmail') {
        const numbersArray = editedNormalEmail.split(',');
        numbersArray.splice(index, 1);
        const updatedNumbers = numbersArray.join(',');
        setEditedNormalEmail(updatedNumbers);
        if (newEditEntryIndexes.editedNormalEmail !== undefined) {
          if (newEditEntryIndexes.editedNormalEmail === index) {
            clearNewEntryIndex('editedNormalEmail', true);
          } else if (newEditEntryIndexes.editedNormalEmail > index) {
            setNewEntryIndex('editedNormalEmail', newEditEntryIndexes.editedNormalEmail - 1, true);
          }
        }
      } else if (type === 'editedCameraDownEmail') {
        const numbersArray = editedCameraDownEmail.split(',');
        numbersArray.splice(index, 1);
        const updatedNumbers = numbersArray.join(',');
        setEditedCameraDownEmail(updatedNumbers);
        if (newEditEntryIndexes.editedCameraDownEmail !== undefined) {
          if (newEditEntryIndexes.editedCameraDownEmail === index) {
            clearNewEntryIndex('editedCameraDownEmail', true);
          } else if (newEditEntryIndexes.editedCameraDownEmail > index) {
            setNewEntryIndex('editedCameraDownEmail', newEditEntryIndexes.editedCameraDownEmail - 1, true);
          }
        }
      } else if (type === 'editedMonthlyDashboardEmail') {
        const numbersArray = editedMonthlyDashboardEmail.split(',');
        numbersArray.splice(index, 1);
        const updatedNumbers = numbersArray.join(',');
        setEditedMonthlyDashboardEmail(updatedNumbers);
        if (newEditEntryIndexes.editedMonthlyDashboardEmail !== undefined) {
          if (newEditEntryIndexes.editedMonthlyDashboardEmail === index) {
            clearNewEntryIndex('editedMonthlyDashboardEmail', true);
          } else if (newEditEntryIndexes.editedMonthlyDashboardEmail > index) {
            setNewEntryIndex('editedMonthlyDashboardEmail', newEditEntryIndexes.editedMonthlyDashboardEmail - 1, true);
          }
        }
      } else if (type === 'editedInvoiceEmail') {
        const numbersArray = editedInvoiceEmail.split(',');
        numbersArray.splice(index, 1);
        const updatedNumbers = numbersArray.join(',');
        setEditedInvoiceEmail(updatedNumbers);
        if (newEditEntryIndexes.editedInvoiceEmail !== undefined) {
          if (newEditEntryIndexes.editedInvoiceEmail === index) {
            clearNewEntryIndex('editedInvoiceEmail', true);
          } else if (newEditEntryIndexes.editedInvoiceEmail > index) {
            setNewEntryIndex('editedInvoiceEmail', newEditEntryIndexes.editedInvoiceEmail - 1, true);
          }
        }
      }
      clearPromptForType(type);
      setEmptyEditFieldErrors((prev) => {
        if (!prev[type]) return prev;
        const next = { ...prev };
        delete next[type];
        return next;
      });
    }
    if (type === 'number') {

      if (!isDataEdited) {
        const numbersArray = contactNumber.split(',');
        numbersArray.splice(index, 1);
        const updatedNumbers = numbersArray.join(',');
        setContactNumber(updatedNumbers);
        if (newEntryIndexes.number !== undefined) {
          if (newEntryIndexes.number === index) {
            clearNewEntryIndex('number', false);
          } else if (newEntryIndexes.number > index) {
            setNewEntryIndex('number', newEntryIndexes.number - 1, false);
          }
        }
        clearPromptForType(type);
        setEmptyFieldErrors((prev) => {
          if (!prev[type]) return prev;
          const next = { ...prev };
          delete next[type];
          return next;
        });
      }
      else {
        const numbersArray = editedNumber.split(',');
        numbersArray.splice(index, 1);
        const updatedNumbers = numbersArray.join(',');
        setEditedNumber(updatedNumbers);
        if (newEditEntryIndexes.number !== undefined) {
          if (newEditEntryIndexes.number === index) {
            clearNewEntryIndex('number', true);
          } else if (newEditEntryIndexes.number > index) {
            setNewEntryIndex('number', newEditEntryIndexes.number - 1, true);
          }
        }
        clearPromptForType(type);
        setEmptyEditFieldErrors((prev) => {
          if (!prev[type]) return prev;
          const next = { ...prev };
          delete next[type];
          return next;
        });
      }

    }
    // else if(type==='editedMonthlyDashboardEmail'){
    // const numbersArray = editedMonthlyDashboardEmail.split(',');
    // numbersArray.splice(index, 1); 
    // const updatedNumbers = numbersArray.join(',');
    // setEditedMonthlyDashboardEmail(updatedNumbers);
    // }
    // else if(type==='editedInvoiceEmail'){
    //   const numbersArray = editedInvoiceEmail.split(',');
    //   numbersArray.splice(index, 1); 
    //   const updatedNumbers = numbersArray.join(',');
    //   setEditedInvoiceEmail(updatedNumbers);
    // }
  };

  // const UpdateEmails = (e) =>{
  //   setEmails(e.target.value)
  // }

  const UpdateEmails = (e, fieldType) => {
    if (fieldType === 'monthlyClientDashboardEmail') {
      setMonthlyClientDashboardEmail(e.target.value);
      clearPromptForType('monthlyClientDashboardEmail');
      setEmptyFieldErrors((prev) => ({ ...prev, monthlyClientDashboardEmail: '' }));
    } else if (fieldType === 'invoiceEmail') {
      setInvoiceEmail(e.target.value);
      clearPromptForType('invoiceEmail');
      setEmptyFieldErrors((prev) => ({ ...prev, invoiceEmail: '' }));
    } else {
      setEmails(e.target.value);
      clearPromptForType('email');
      setEmptyFieldErrors((prev) => ({ ...prev, email: '' }));
    }
  }

  const handleNumberChange = (event, index, type) => {
    if (type === 'email' || type === "editedHighEmail" || type === "editedNormalEmail" ||
      type === "highEmails" || type === "lowEmails" || type === "cameraDownEmails" ||
      type === "editedCameraDownEmail" || type === "monthlyClientDashboardEmail" ||
      type === "invoiceEmail" || type === "editedMonthlyDashboardEmail" ||
      type === "editedInvoiceEmail") {

      if (!isDataEdited) {
        if (type === 'email') {
          const numbersArray = emails.split(',');
          numbersArray[index] = event.target.value;
          const updatedNumbers = numbersArray.join(',');
          setEmails(updatedNumbers);
          clearPromptForType('email');
          setEmptyFieldErrors((prev) => ({ ...prev, email: '' }));
        } else if (type === "highEmails") {
          const numbersArray = highEmails.split(',');
          numbersArray[index] = event.target.value;
          const updatedNumbers = numbersArray.join(',');
          setHighEmails(updatedNumbers);
          clearPromptForType('highEmails');
          setEmptyFieldErrors((prev) => ({ ...prev, highEmails: '' }));
        } else if (type === "lowEmails") {
          const numbersArray = lowEmails.split(',');
          numbersArray[index] = event.target.value;
          const updatedNumbers = numbersArray.join(',');
          setLowEmails(updatedNumbers);
          clearPromptForType('lowEmails');
          setEmptyFieldErrors((prev) => ({ ...prev, lowEmails: '' }));
        } else if (type === "cameraDownEmails") {
          const numbersArray = cameraDownEmails.split(',');
          numbersArray[index] = event.target.value;
          const updatedNumbers = numbersArray.join(',');
          setCameraDownEmails(updatedNumbers);
          clearPromptForType('cameraDownEmails');
          setEmptyFieldErrors((prev) => ({ ...prev, cameraDownEmails: '' }));
        } else if (type === "monthlyClientDashboardEmail") {
          const numbersArray = monthlyClientDashboardEmail.split(',');
          numbersArray[index] = event.target.value;
          const updatedNumbers = numbersArray.join(',');
          setMonthlyClientDashboardEmail(updatedNumbers);
          clearPromptForType('monthlyClientDashboardEmail');
          setEmptyFieldErrors((prev) => ({ ...prev, monthlyClientDashboardEmail: '' }));
        } else if (type === "invoiceEmail") {
          const numbersArray = invoiceEmail.split(',');
          numbersArray[index] = event.target.value;
          const updatedNumbers = numbersArray.join(',');
          setInvoiceEmail(updatedNumbers);
          clearPromptForType('invoiceEmail');
          setEmptyFieldErrors((prev) => ({ ...prev, invoiceEmail: '' }));
        }
      } else {
        // Edit mode
        if (type === "email") {
          const numbersArray = editedmail.split(',');
          numbersArray[index] = event.target.value;
          const updatedNumbers = numbersArray.join(',');
          setEditedMail(updatedNumbers);
          clearPromptForType('email');
          setEmptyEditFieldErrors((prev) => ({ ...prev, email: '' }));
        } else if (type === "editedHighEmail") {
          const numbersArray = editedHighEmail.split(',');
          numbersArray[index] = event.target.value;
          const updatedNumbers = numbersArray.join(',');
          setEditedHighEmail(updatedNumbers);
          clearPromptForType('editedHighEmail');
          setEmptyEditFieldErrors((prev) => ({ ...prev, editedHighEmail: '' }));
        } else if (type === "editedNormalEmail") {
          const numbersArray = editedNormalEmail.split(',');
          numbersArray[index] = event.target.value;
          const updatedNumbers = numbersArray.join(',');
          setEditedNormalEmail(updatedNumbers);
          clearPromptForType('editedNormalEmail');
          setEmptyEditFieldErrors((prev) => ({ ...prev, editedNormalEmail: '' }));
        } else if (type === "editedCameraDownEmail") {
          const numbersArray = editedCameraDownEmail.split(',');
          numbersArray[index] = event.target.value;
          const updatedNumbers = numbersArray.join(',');
          setEditedCameraDownEmail(updatedNumbers);
          clearPromptForType('editedCameraDownEmail');
          setEmptyEditFieldErrors((prev) => ({ ...prev, editedCameraDownEmail: '' }));
        } else if (type === "editedMonthlyDashboardEmail") {
          const numbersArray = editedMonthlyDashboardEmail.split(',');
          numbersArray[index] = event.target.value;
          const updatedNumbers = numbersArray.join(',');
          setEditedMonthlyDashboardEmail(updatedNumbers);
          clearPromptForType('editedMonthlyDashboardEmail');
          setEmptyEditFieldErrors((prev) => ({ ...prev, editedMonthlyDashboardEmail: '' }));
        } else if (type === "editedInvoiceEmail") {
          const numbersArray = editedInvoiceEmail.split(',');
          numbersArray[index] = event.target.value;
          const updatedNumbers = numbersArray.join(',');
          setEditedInvoiceEmail(updatedNumbers);
          clearPromptForType('editedInvoiceEmail');
          setEmptyEditFieldErrors((prev) => ({ ...prev, editedInvoiceEmail: '' }));
        }
      }
    }
    else if (type === 'number') {

      if (!isDataEdited) {
        let value = event.target.value;
        value = value.replace(/\D/g, '')
        value = value.slice(0, 20)

        const numbersArray = contactNumber.split(',');
        numbersArray[index] = value;
        const updatedNumbers = numbersArray.join(',');
        setContactNumber(updatedNumbers);
        clearPromptForType('number');
        setEmptyFieldErrors((prev) => ({ ...prev, number: '' }));
      }
      else {
        let value = event.target.value;
        value = value.replace(/\D/g, '')
        value = value.slice(0, 20)

        const numbersArray = editedNumber.split(',');
        numbersArray[index] = value;
        const updatedNumbers = numbersArray.join(',');
        setEditedNumber(updatedNumbers);
        clearPromptForType('number');
        setEmptyEditFieldErrors((prev) => ({ ...prev, number: '' }));
      }
    }
    // else if(type==="editedMonthlyDashboardEmail"){
    //   const numbersArray = editedMonthlyDashboardEmail.split(',');
    //   numbersArray[index] = event.target.value;
    //   const updatedNumbers = numbersArray.join(',');
    //   setEditedMonthlyDashboardEmail(updatedNumbers);
    // }
    // else if(type==="editedInvoiceEmail"){
    //   const numbersArray = editedInvoiceEmail.split(',');
    //   numbersArray[index] = event.target.value;
    //   const updatedNumbers = numbersArray.join(',');
    //   setEditedInvoiceEmail(updatedNumbers);
    // }
  };
  return (
    <>
    <Page title="Email Reports">
      <Container maxWidth="xxl" sx={{ p: 0 }}>
        <Box sx={{ mb: 4 }}>
          <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4">Email Reports</Typography>
          </Box>
          <Breadcrumbs separator="•" aria-label="breadcrumb">
            <DashboardBreadcrumbLink sx={{ fontSize: '0.875rem' }} />
            <Typography color="text.secondary" sx={{ fontSize: '0.875rem' }}>Settings</Typography>
            <Typography color="text.primary" sx={{ fontSize: '0.875rem' }}>Email Reports</Typography>
          </Breadcrumbs>
        </Box>
        <Card variant="outlined" sx={{ p: 0 }}>
            <CardContent sx={{p:2}}>

            <Grid container spacing={3} alignItems="flex-start">
              {!isReseller && (<Grid item {...topFieldGrid} mt={3}>
                <FormControl fullWidth sx={topControlSx}>
                  <InputLabel id="demo-simple-select-labell">Client Type</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={clientType}
                    label="Client Type"
                    onChange={handleClientType}               
                  >

                    <MenuItem value="US">US</MenuItem>
                    <MenuItem value="INDIA">INDIA</MenuItem>

                  </Select>
                  {clientTypeerror && <Typography variant="body2" color="error">{clientTypeerror}</Typography>}


                </FormControl>
              </Grid>)}
              <Grid item {...topFieldGrid} mt={3}>
                <FormControl fullWidth>
                  <Autocomplete
                    fullWidth
                    id="tags-outlined"
                    // options={setTypeClient.map((client, clientIndex) => ({
                    //   ...client,
                    //   customKey: clientIndex, // Assuming clientId is a unique identifier
                    // }))}
                    options={uniqueClientOptions}
                    // isOptionEqualToValue={(option, value) =>
                    //   option.customKey === value.customKey
                    // }
                    // getOptionLabel={(option) => option.displayname}
                    isOptionEqualToValue={(option, value) => option.ID === value?.ID}
                    getOptionLabel={(option) => `${option.displayname || ''}`}
                    value={uniqueClientOptions.find((option) => option.ID === client) || null}
                    onChange={onClientChange}
                    //value={client.ID}
                    filterSelectedOptions
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Clients"
                        placeholder="Enter Client Name"
                        sx={topControlSx}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li {...props} key={option.ID}>
                        {option.displayname}
                      </li>
                    )}
                  />
                </FormControl>
                {errorClientMessage && <Typography color="error" variant="body2" align="left">{errorClientMessage}</Typography>}
                {errorClientMessage1 && <Typography color="error" variant="body2" align="left">{errorClientMessage1}</Typography>}


              </Grid>

              {showLocationDropdown && (
                <Grid item {...topFieldGrid} mt={3}>
                  <FormControl fullWidth>
                    <Autocomplete
                      multiple
                      id="email-report-locations"
                      options={clientLocationOptions}
                      value={clientLocationOptions.filter((locationItem) =>
                        selectedClientLocations.includes(locationItem.ID || locationItem.id)
                      )}
                      getOptionLabel={(option) => option.selectall ? option.title : `${option.Location || ''}`}
                      onChange={handleLocationChange}
                      disableCloseOnSelect
                      filterOptions={handleLocationFilterOptions}
                      renderTags={() => null}
                      renderOption={(props, option) => (
                        <li {...props}>
                          {option.selectall ? (
                            <>
                              <Checkbox
                                style={{ marginRight: 8 }}
                                checked={locationCheckValue}
                              />
                              {option.title}
                            </>
                          ) : (
                            <>
                              <Checkbox
                                style={{ marginRight: 8 }}
                                checked={selectedClientLocations.includes(option.ID || option.id)}
                              />
                              {option.Location}
                            </>
                          )}
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField {...params} label="Locations" placeholder="Select Locations" sx={topControlSx} />
                      )}
                    />
                  </FormControl>
                  {locationErrorMessage && (
                    <Typography color="error" variant="body2" align="left">
                      {locationErrorMessage}
                    </Typography>
                  )}
                </Grid>
              )}

              <Grid item {...contactFieldGrid}>
                <InputLabel shrink>
                  Daily Emails
                </InputLabel>
                <Box
                  sx={{
                    border: (theme) => '1px solid ' + theme.palette.divider,
                    padding: '8px',
                    borderRadius: '8px',
                    minHeight: emails ? 'auto' : '50px', 
                  }}
                  onClick={() => handleBoxClick('email')}
                >
                  {addEmptyBox[0].email && (
                    <Box
                      sx={{
                        marginBottom: 1,
                        width:'80%',
                        backgroundColor: (theme) => theme.palette.action.selected,
                        position:'relative',
                        borderRadius: '100px',
                        border:'none',
                        borderColor:'none'
                      }}
                    >
                      <TextField
                        onClick={(e) => {
                          e.stopPropagation()
                        }}
                        placeholder='Add Email'
                        value={emails}
                        onChange={(e) => UpdateEmails(e,'email')}
                        fullWidth
                        size="small"
                        sx={{
                          '& input': {
                            height: '14px', 
                            fontSize: '14px',
                            color: (theme) => theme.palette.text.primary,
                            "&::placeholder": {
                              color: (theme) => theme.palette.text.secondary,
                              opacity: 1,
                            },
                          },
                          '& fieldset': {
                            border:'none'
                          },
                        }}
                      />
                      <Box
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          right: '8px',
                          transform: 'translateY(-50%)',
                          width: '15px',
                          height: '15px',
                          borderRadius: '50%',
                          backgroundColor: (theme) => theme.palette.action.selected,
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}>
                        <IconButton
                          onClick={(e) => removeNumber(e, 0, 'email')}
                        >
                          <CloseIcon fontSize="small" sx={{ fontSize: '14px', color: 'text.secondary' }} />
                        </IconButton>
                      </Box>
                    </Box>
                  )}

                  {!addEmptyBox[0].email && emails.split(',').map((email, index) => (

                    <Box
                      key={index}
                      sx={{
                        marginBottom: 1,
                        width:'80%',
                        backgroundColor: (theme) => theme.palette.action.selected,
                        position:'relative',
                        borderRadius: '100px',
                        border:'none',
                        borderColor:'none'
                      }}
                    >
                      <TextField
                        //className={classes.root}
                        placeholder='Add Email'
                        value={email}
                        onClick={(e) => {
                          e.stopPropagation()
                        }}
                        onChange={(e) => handleNumberChange(e, index, 'email')}
                        fullWidth
                        size="small"
                        sx={{
                          '& input': {
                            height: '14px', 
                            fontSize: '14px',
                            color: (theme) => theme.palette.text.primary,
                            "&::placeholder": {
                              color: (theme) => theme.palette.text.secondary,
                              opacity: 1,
                            },
                          },
                          '& fieldset': {
                            border:'none'
                          },
                        }}
                      />
                      <Box
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          right: '8px',
                          transform: 'translateY(-50%)',
                          width: '15px',
                          height: '15px',
                          borderRadius: '50%',
                          backgroundColor: (theme) => theme.palette.action.selected,
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}>
                        <IconButton
                          onClick={(e) => removeNumber(e, index, 'email')}
                        >
                          <CloseIcon fontSize="small" sx={{ fontSize: '14px', color: 'text.secondary' }} />
                        </IconButton>
                      </Box>
                    </Box>

                  ))}

                </Box>
                {emailErrorMessage && <Typography color="error" variant="body2" align="left" marginTop={1}>{emailErrorMessage}</Typography>}
                {emptyFieldErrors.email && <Typography color="error" variant="body2" align="left" marginTop={1}>{emptyFieldErrors.email}</Typography>}
                {shouldShowPrompt('email', false) && (
                  <Typography color="error" variant="body2" align="left" marginTop={1}>
                    {emptyFieldPrompts.email}
                  </Typography>
                )}
                </Grid>
              <Grid item {...contactFieldGrid}>
                <InputLabel shrink>
                  Escalation Email : High
                </InputLabel>
                <Box
                  sx={{
                    border: (theme) => '1px solid ' + theme.palette.divider,
                    padding: '8px',
                    borderRadius: '8px',
                    minHeight: highEmails ? 'auto' : '50px', 
                  }}
                  onClick={() => handleBoxClick('highEmails')}
                >
                  {addEmptyBox[0].highEmails && (
                    <Box
                      sx={{
                        marginBottom: 1,
                        width:'80%',
                        backgroundColor: (theme) => theme.palette.action.selected,
                        position:'relative',
                        borderRadius: '100px',
                        border:'none',
                        borderColor:'none'
                      }}
                    >
                      <TextField
                        onClick={(e) => {
                          e.stopPropagation()
                        }}
                        placeholder='Add High Priority Email'
                        value={highEmails}
                        onChange={(e) => handleNumberChange(e, 0, 'highEmails')}
                        fullWidth
                        size="small"
                        sx={{
                          '& input': {
                            height: '14px', 
                            fontSize: '14px',
                            color: (theme) => theme.palette.text.primary,
                            "&::placeholder": {
                              color: (theme) => theme.palette.text.secondary,
                              opacity: 1,
                            },
                          },
                          '& fieldset': {
                            border:'none'
                          },
                        }}
                      />
                      <Box
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          right: '8px',
                          transform: 'translateY(-50%)',
                          width: '15px',
                          height: '15px',
                          borderRadius: '50%',
                          backgroundColor: (theme) => theme.palette.action.selected,
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}
                      >
                        <IconButton
                          onClick={(e) => removeNumber(e, 0, 'highEmails')}
                        >
                          <CloseIcon fontSize="small" sx={{ fontSize: '14px', color: 'text.secondary' }} />
                        </IconButton>
                      </Box>
                    </Box>
                  )}

                  {!addEmptyBox[0].highEmails && highEmails.split(',').map((email, index) => (

                    <Box
                      key={index}
                      sx={{
                        marginBottom: 1,
                        width:'80%',
                        backgroundColor: (theme) => theme.palette.action.selected,
                        position:'relative',
                        borderRadius: '100px',
                        border:'none',
                        borderColor:'none'
                      }}
                    >
                      <TextField
                        //className={classes.root}
                        placeholder='Add High Priority Email'
                        value={email}
                        onClick={(e) => {
                          e.stopPropagation()
                        }}
                        onChange={(e) => handleNumberChange(e, index, 'highEmails')}
                        fullWidth
                        size="small"
                        sx={{
                          '& input': {
                            height: '14px', 
                            fontSize: '14px',
                            color: (theme) => theme.palette.text.primary,
                            "&::placeholder": {
                              color: (theme) => theme.palette.text.secondary,
                              opacity: 1,
                            },
                          },
                          '& fieldset': {
                            border:'none'
                          },
                        }}
                      />
                      <Box
                         sx={{
                          position: 'absolute',
                          top: '50%',
                          right: '8px',
                          transform: 'translateY(-50%)',
                          width: '15px',
                          height: '15px',
                          borderRadius: '50%',
                          backgroundColor: (theme) => theme.palette.action.selected,
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}>
                        <IconButton
                          onClick={(e) => removeNumber(e, index, 'highEmails')}
                        >
                          <CloseIcon fontSize="small" sx={{ fontSize: '14px', color: 'text.secondary' }} />
                        </IconButton>
                      </Box>
                    </Box>

                  ))}

                </Box>
                {highErrorMessage && <Typography color="error" variant="body2" align="left" marginTop={1}>{highErrorMessage}</Typography>}
                {emptyFieldErrors.highEmails && <Typography color="error" variant="body2" align="left" marginTop={1}>{emptyFieldErrors.highEmails}</Typography>}
                {shouldShowPrompt('highEmails', false) && (
                  <Typography color="error" variant="body2" align="left" marginTop={1}>
                    {emptyFieldPrompts.highEmails}
                  </Typography>
                )}
              </Grid>
              <Grid item {...contactFieldGrid}>
                <InputLabel shrink>
                  Escalation Email : Low
                </InputLabel>
                <Box
                  sx={{
                    border: (theme) => '1px solid ' + theme.palette.divider,
                    padding: '8px',
                    borderRadius: '8px',
                    minHeight: lowEmails ? 'auto' : '50px',
                  }}
                  onClick={() => handleBoxClick('lowEmails')}
                >
                  {addEmptyBox[0].lowEmails && (
                    <Box
                      sx={{
                        marginBottom: 1,
                        width:'80%',
                        backgroundColor: (theme) => theme.palette.action.selected,
                        position:'relative',
                        borderRadius: '100px',
                        border:'none',
                        borderColor:'none'
                      }}
                    >
                      <TextField
                        onClick={(e) => {
                          e.stopPropagation()
                        }}
                        placeholder='Add Low Priority Email'
                        value={lowEmails}
                        onChange={(e) => handleNumberChange(e, 0, 'lowEmails')}
                        fullWidth
                        size="small"
                        sx={{
                          '& input': {
                            height: '14px', 
                            fontSize: '14px',
                            color: (theme) => theme.palette.text.primary,
                            "&::placeholder": {
                              color: (theme) => theme.palette.text.secondary,
                              opacity: 1,
                            },
                          },
                          '& fieldset': {
                            border:'none'
                          },
                        }}
                      />
                      <Box
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          right: '8px',
                          transform: 'translateY(-50%)',
                          width: '15px',
                          height: '15px',
                          borderRadius: '50%',
                          backgroundColor: (theme) => theme.palette.action.selected,
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}>
                        <IconButton
                          onClick={(e) => removeNumber(e, 0, 'lowEmails')}
                        >
                          <CloseIcon fontSize="small" sx={{ fontSize: '14px', color: 'text.secondary' }} />
                        </IconButton>
                      </Box>
                    </Box>
                  )}

                  {!addEmptyBox[0].lowEmails && lowEmails.split(',').map((email, index) => (

                    <Box
                      key={index}
                      sx={{
                        marginBottom: 1,
                        width:'80%',
                        backgroundColor: (theme) => theme.palette.action.selected,
                        position:'relative',
                        borderRadius: '100px',
                        border:'none',
                        borderColor:'none'
                      }}
                    >
                      <TextField
                        //className={classes.root}
                        placeholder='Add Low Priority Email'
                        value={email}
                        onClick={(e) => {
                          e.stopPropagation()
                        }}
                        onChange={(e) => handleNumberChange(e, index, 'lowEmails')}
                        fullWidth
                        size="small"
                        sx={{
                          '& input': {
                            height: '14px', 
                            fontSize: '14px',
                            color: (theme) => theme.palette.text.primary,
                            "&::placeholder": {
                              color: (theme) => theme.palette.text.secondary,
                              opacity: 1,
                            },
                          },
                          '& fieldset': {
                            border:'none'
                          },
                        }}
                      />
                      <Box
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          right: '8px',
                          transform: 'translateY(-50%)',
                          width: '15px',
                          height: '15px',
                          borderRadius: '50%',
                          backgroundColor: (theme) => theme.palette.action.selected,
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}>
                        <IconButton
                          onClick={(e) => removeNumber(e, index, 'lowEmails')}
                        >
                          <CloseIcon fontSize="small" sx={{ fontSize: '14px', color: 'text.secondary' }} />
                        </IconButton>
                      </Box>
                    </Box>

                  ))}

                </Box>
                {lowErrorMessage && <Typography color="error" variant="body2" align="left" marginTop={1}>{lowErrorMessage}</Typography>}
                {emptyFieldErrors.lowEmails && <Typography color="error" variant="body2" align="left" marginTop={1}>{emptyFieldErrors.lowEmails}</Typography>}
                {shouldShowPrompt('lowEmails', false) && (
                  <Typography color="error" variant="body2" align="left" marginTop={1}>
                    {emptyFieldPrompts.lowEmails}
                  </Typography>
                )}
              </Grid>
              <Grid item {...contactFieldGrid}>
                <InputLabel shrink>
                  Monthly Client Dashboard Email
                </InputLabel>
                <Box
                  sx={{
                    border: (theme) => '1px solid ' + theme.palette.divider,
                    padding: '8px',
                    borderRadius: '8px',
                    minHeight: monthlyClientDashboardEmail ? 'auto' : '50px',
                  }}
                  onClick={() => handleBoxClick('monthlyClientDashboardEmail')}
                >
                  {addEmptyBox[0].monthlyClientDashboardEmail && (
                    <Box
                      sx={{
                        marginBottom: 1,
                        width:'80%',
                        backgroundColor: (theme) => theme.palette.action.selected,
                        position:'relative',
                        borderRadius: '100px',
                        border:'none',
                        borderColor:'none'
                      }}
                    >
                      <TextField
                        onClick={(e) => {
                          e.stopPropagation()
                        }}
                        placeholder='Add Monthly Client Dashboard Email'
                        value={monthlyClientDashboardEmail}
                        onChange={(e) => UpdateEmails(e, 'monthlyClientDashboardEmail')}
                        fullWidth
                        size="small"
                        sx={{
                          '& input': {
                            height: '14px', 
                            fontSize: '14px',
                            color: (theme) => theme.palette.text.primary,
                            "&::placeholder": {
                              color: (theme) => theme.palette.text.secondary,
                              opacity: 1,
                            },
                          },
                          '& fieldset': {
                            border:'none'
                          },
                        }}
                      />
                      <Box
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          right: '8px',
                          transform: 'translateY(-50%)',
                          width: '15px',
                          height: '15px',
                          borderRadius: '50%',
                          backgroundColor: (theme) => theme.palette.action.selected,
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}>
                        <IconButton
                          onClick={(e) => removeNumber(e, 0, 'monthlyClientDashboardEmail')}
                        >
                          <CloseIcon fontSize="small" sx={{ fontSize: '14px', color: 'text.secondary' }} />
                        </IconButton>
                      </Box>
                    </Box>
                  )}

                  {!addEmptyBox[0].monthlyClientDashboardEmail && monthlyClientDashboardEmail.split(',').map((email, index) => (

                    <Box
                      key={index}
                      sx={{
                        marginBottom: 1,
                        width:'80%',
                        backgroundColor: (theme) => theme.palette.action.selected,
                        position:'relative',
                        borderRadius: '100px',
                        border:'none',
                        borderColor:'none'
                      }}
                    >
                      <TextField
                        //className={classes.root}
                        placeholder='Add Monthly Client Dashboard Email'
                        value={email}
                        onClick={(e) => {
                          e.stopPropagation()
                        }}
                        onChange={(e) => handleNumberChange(e, index, 'monthlyClientDashboardEmail')}
                        fullWidth
                        size="small"
                        sx={{
                          '& input': {
                            height: '14px', 
                            fontSize: '14px',
                            color: (theme) => theme.palette.text.primary,
                            "&::placeholder": {
                              color: (theme) => theme.palette.text.secondary,
                              opacity: 1,
                            },
                          },
                          '& fieldset': {
                            border:'none'
                          },
                        }}
                      />
                      <Box
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          right: '8px',
                          transform: 'translateY(-50%)',
                          width: '15px',
                          height: '15px',
                          borderRadius: '50%',
                          backgroundColor: (theme) => theme.palette.action.selected,
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}>
                        <IconButton
                          onClick={(e) => removeNumber(e, index, 'monthlyClientDashboardEmail')}
                        >
                          <CloseIcon fontSize="small" sx={{ fontSize: '14px', color: 'text.secondary' }} />
                        </IconButton>
                      </Box>
                    </Box>

                  ))}

                </Box>
                {monthlyClientErrorMessage && <Typography color="error" variant="body2" align="left" marginTop={1}>{monthlyClientErrorMessage}</Typography>}
                {emptyFieldErrors.monthlyClientDashboardEmail && <Typography color="error" variant="body2" align="left" marginTop={1}>{emptyFieldErrors.monthlyClientDashboardEmail}</Typography>}
                {shouldShowPrompt('monthlyClientDashboardEmail', false) && (
                  <Typography color="error" variant="body2" align="left" marginTop={1}>
                    {emptyFieldPrompts.monthlyClientDashboardEmail}
                  </Typography>
                )}
              </Grid>
              {/* <Grid item md={2.5}>
                <InputLabel shrink>
                  Invoice Email
                </InputLabel>
                <Box
                  sx={{
                    border: '1px solid #b4b4b4',
                    padding: '8px',
                    borderRadius: '8px',
                    minHeight: invoiceEmail ? 'auto' : '50px',
                  }}
                  onClick={() => handleBoxClick('invoiceEmail')}
                >
                  {addEmptyBox[0].invoiceEmail && !invoiceEmail && (
                    <Box
                      sx={{
                        marginBottom: 1,
                        width: '80%',
                        backgroundColor: '#E8E8E8',
                        position: 'relative',
                        borderRadius: '100px',
                        border: 'none',
                        borderColor: 'none'
                      }}
                    >
                      <TextField
                        onClick={(e) => {
                          e.stopPropagation()
                        }}
                        placeholder='Add Invoice Email'
                        onChange={(e) => UpdateEmails(e, 'invoiceEmail')}
                        fullWidth
                        size="small"
                        sx={{
                          '& input': {
                            height: '14px',
                            fontSize: '14px',
                            color: '#000',
                            "&::placeholder": {
                              color: "#000",
                              opacity: 1,
                            },
                          },
                          '& fieldset': {
                            border: 'none'
                          },
                        }}
                      />
                      <Box
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          right: '8px',
                          transform: 'translateY(-50%)',
                          width: '15px',
                          height: '15px',
                          borderRadius: '50%',
                          backgroundColor: '#E8E8E8',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}>
                        <IconButton
                          onClick={(e) => removeNumber(e, 0, 'invoiceEmail')}
                        >
                          <CloseIcon fontSize="small" style={{ fontSize: '14px', color: '#000' }} />
                        </IconButton>
                      </Box>
                    </Box>
                  )}

                  {!addEmptyBox[0].invoiceEmail && invoiceEmail.split(',').map((email, index) => (

                    <Box
                      key={index}
                      sx={{
                        marginBottom: 1,
                        width: '80%',
                        backgroundColor: '#E8E8E8',
                        position: 'relative',
                        borderRadius: '100px',
                        border: 'none',
                        borderColor: 'none'
                      }}
                    >
                      <TextField
                        //className={classes.root}
                        placeholder='Add Invoice Email'
                        value={email}
                        onClick={(e) => {
                          e.stopPropagation()
                        }}
                        onChange={(e) => handleNumberChange(e, index, 'invoiceEmail')}
                        fullWidth
                        size="small"
                        sx={{
                          '& input': {
                            height: '14px',
                            fontSize: '14px',
                            color: '#000',
                            "&::placeholder": {
                              color: "#000",
                              opacity: 1,
                            },
                          },
                          '& fieldset': {
                            border: 'none'
                          },
                        }}
                      />
                      <Box
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          right: '8px',
                          transform: 'translateY(-50%)',
                          width: '15px',
                          height: '15px',
                          borderRadius: '50%',
                          backgroundColor: '#E8E8E8',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}>
                        <IconButton
                          onClick={(e) => removeNumber(e, index, 'invoiceEmail')}
                        >
                          <CloseIcon fontSize="small" style={{ fontSize: '14px', color: '#000' }} />
                        </IconButton>
                      </Box>
                    </Box>

                  ))}

                </Box>
                {invoiceEmailErrorMessage && <Typography color="error" variant="body2" align="left" marginTop={1}>{invoiceEmailErrorMessage}</Typography>}
              </Grid> */}
              <Grid item {...contactFieldGrid}>
                <InputLabel shrink>
                  Camera online/offline Email
                </InputLabel>
                <Box
                  sx={{
                    border: (theme) => '1px solid ' + theme.palette.divider,
                    padding: '8px',
                    borderRadius: '8px',
                    minHeight: cameraDownEmails ? 'auto' : '50px',
                  }}
                  onClick={() => handleBoxClick('cameraDownEmails')}
                >
                  {addEmptyBox[0].cameraDownEmails && (
                    <Box
                      sx={{
                        marginBottom: 1,
                        width: '80%',
                        backgroundColor: '#E8E8E8',
                        position: 'relative',
                        borderRadius: '100px',
                        border: 'none',
                        borderColor: 'none'
                      }}
                    >
                      <TextField
                        onClick={(e) => {
                          e.stopPropagation()
                        }}
                        placeholder='Add Camera online/offline Email'
                        value={cameraDownEmails}
                        onChange={(e) => handleNumberChange(e, 0, 'cameraDownEmails')}
                        fullWidth
                        size="small"
                        sx={{
                          '& input': {
                            height: '14px', 
                            fontSize: '14px',
                            color: (theme) => theme.palette.text.primary,
                            "&::placeholder": {
                              color: (theme) => theme.palette.text.secondary,
                              opacity: 1,
                            },
                          },
                          '& fieldset': {
                            border:'none'
                          },
                        }}
                      />
                      <Box
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          right: '8px',
                          transform: 'translateY(-50%)',
                          width: '15px',
                          height: '15px',
                          borderRadius: '50%',
                          backgroundColor: (theme) => theme.palette.action.selected,
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}>
                        <IconButton
                          onClick={(e) => removeNumber(e, 0, 'cameraDownEmails')}
                        >
                          <CloseIcon fontSize="small" sx={{ fontSize: '14px', color: 'text.secondary' }} />
                        </IconButton>
                      </Box>
                    </Box>
                  )}

                  {!addEmptyBox[0].cameraDownEmails && cameraDownEmails.split(',').map((email, index) => (

                    <Box
                      key={index}
                      sx={{
                        marginBottom: 1,
                        width:'80%',
                        backgroundColor: (theme) => theme.palette.action.selected,
                        position:'relative',
                        borderRadius: '100px',
                        border:'none',
                        borderColor:'none'
                      }}
                    >
                      <TextField
                        //className={classes.root}
                        placeholder='Add Camera online/offline Email'
                        value={email}
                        onClick={(e) => {
                          e.stopPropagation()
                        }}
                        onChange={(e) => handleNumberChange(e, index, 'cameraDownEmails')}
                        fullWidth
                        size="small"
                        sx={{
                          '& input': {
                            height: '14px', 
                            fontSize: '14px',
                            color: (theme) => theme.palette.text.primary,
                            "&::placeholder": {
                              color: (theme) => theme.palette.text.secondary,
                              opacity: 1,
                            },
                          },
                          '& fieldset': {
                            border:'none'
                          },
                        }}
                      />
                      <Box
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          right: '8px',
                          transform: 'translateY(-50%)',
                          width: '15px',
                          height: '15px',
                          borderRadius: '50%',
                          backgroundColor: (theme) => theme.palette.action.selected,
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}>
                        <IconButton
                          onClick={(e) => removeNumber(e, index, 'cameraDownEmails')}
                        >
                          <CloseIcon fontSize="small" sx={{ fontSize: '14px', color: 'text.secondary' }} />
                        </IconButton>
                      </Box>
                    </Box>

                  ))}

                </Box>
                {cameraDownErrorMessage && <Typography color="error" variant="body2" align="left" marginTop={1}>{cameraDownErrorMessage}</Typography>}
                {emptyFieldErrors.cameraDownEmails && <Typography color="error" variant="body2" align="left" marginTop={1}>{emptyFieldErrors.cameraDownEmails}</Typography>}
                {shouldShowPrompt('cameraDownEmails', false) && (
                  <Typography color="error" variant="body2" align="left" marginTop={1}>
                    {emptyFieldPrompts.cameraDownEmails}
                  </Typography>
                )}
              </Grid>
              <Grid item {...contactFieldGrid}>
                <InputLabel shrink>
                  Contact Number
                </InputLabel>
                <Box
                  sx={{
                    border: (theme) => '1px solid ' + theme.palette.divider,
                    padding: '8px',
                    borderRadius: '8px',
                    minHeight: contactNumber ? 'auto' : '50px',
                  }}
                  onClick={() => handleBoxClick('number')}
                >
                  {addEmptyBox[0].number && (
                    <Box
                      sx={{
                        marginBottom: 1,
                        width:'80%',
                        backgroundColor: (theme) => theme.palette.action.selected,
                        position:'relative',
                        borderRadius: '100px',
                        border:'none',
                        borderColor:'none'
                      }}
                    >
                      <TextField
                        onClick={(e) => {
                          e.stopPropagation()
                        }}
                        type='number'
                        placeholder='Add Contact Number'
                        value={contactNumber}
                        onChange={(e) => handleNumberChange(e, 0, 'number')}
                        fullWidth
                        size="small"
                        sx={{
                          '& input': {
                            height: '14px', 
                            fontSize: '14px',
                            color: (theme) => theme.palette.text.primary,
                            "&::placeholder": {
                              color: (theme) => theme.palette.text.secondary,
                              opacity: 1,
                            },
                          },
                          '& fieldset': {
                            border:'none'
                          },
                        }}
                      />
                      <Box
                      sx={{
                        position: 'absolute',
                        top: '50%',
                        right: '8px',
                        transform: 'translateY(-50%)',
                        width: '15px',
                        height: '15px',
                        borderRadius: '50%',
                        backgroundColor: (theme) => theme.palette.action.selected,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                      }}>
                        <IconButton
                          onClick={(e) => removeNumber(e, 0, 'number')}
                        >
                          <CloseIcon fontSize="small" sx={{ fontSize: '14px', color: 'text.secondary' }} />
                        </IconButton>
                      </Box>
                    </Box>
                  )}

                  {!addEmptyBox[0].number && contactNumber.split(',').map((number, index) => (

                    <Box
                      key={index}
                      sx={{
                        marginBottom: 1,
                        width:'80%',
                        backgroundColor: (theme) => theme.palette.action.selected,
                        position:'relative',
                        borderRadius: '100px',
                        border:'none',
                        borderColor:'none'
                      }}
                    >
                      <TextField
                        //className={classes.root}
                        placeholder='Add Contact Number'
                        type='number'
                        value={number}
                        onClick={(e) => {
                          e.stopPropagation()
                        }}
                        onChange={(e) => handleNumberChange(e, index, 'number')}
                        fullWidth
                        size="small"
                        sx={{
                          '& input': {
                            height: '14px', 
                            fontSize: '14px',
                            color: (theme) => theme.palette.text.primary,
                            "&::placeholder": {
                              color: (theme) => theme.palette.text.secondary,
                              opacity: 1,
                            },
                          },
                          '& fieldset': {
                            border:'none'
                          },
                        }}
                      />
                      <Box
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          right: '8px',
                          transform: 'translateY(-50%)',
                          width: '15px',
                          height: '15px',
                          borderRadius: '50%',
                          backgroundColor: (theme) => theme.palette.action.selected,
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}>
                        <IconButton
                          onClick={(e) => removeNumber(e, index, 'number')}
                        >
                          <CloseIcon fontSize="small" sx={{ fontSize: '14px', color: 'text.secondary' }} />
                        </IconButton>
                      </Box>
                    </Box>

                  ))}

                </Box>

                {mobileErrorMessage && <Typography color="error" variant="body2" align="left" marginTop={1}>{mobileErrorMessage}</Typography>}
                {emptyFieldErrors.number && <Typography color="error" variant="body2" align="left" marginTop={1}>{emptyFieldErrors.number}</Typography>}
                {shouldShowPrompt('number', false) && (
                  <Typography color="error" variant="body2" align="left" marginTop={1}>
                    {emptyFieldPrompts.number}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12}>
                <Box
                  display="flex"
                  gap={2}
                  justifyContent={{ xs: 'stretch', sm: 'flex-end' }}
                  flexDirection={{ xs: 'column', sm: 'row' }}
                >
                  <LoadingButton disabled={submitDisbale} type="submit" variant="contained" onClick={handleSave}>
                    Save
                  </LoadingButton>
                  <Button color="error" variant="contained" onClick={handleClear}>
                    Clear
                  </Button>
                </Box>
              </Grid>

            </Grid>

            <Grid container spacing={3} alignItems="center" sx={{ marginTop: "1rem", marginLeft:"0rem", width:'100%' }}>
              <TableContainer
                component={Paper}
                sx={{
                  maxWidth: '100%',
                  overflowX: 'auto',
                  '& .MuiTableCell-head': {
                    whiteSpace: 'nowrap',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    padding: '12px 8px'
                  },
                  '& .MuiTableCell-body': {
                    fontSize: '14px',
                    padding: '12px 8px',
                  }
                }}
              >
                <Table stickyHeader>
                  <TableHead sx={{ background: '#f3f3f3' }}>
                    <TableRow sx={{ background: '#f3f3f3' }}>
                      <TableCell>S.No</TableCell>
                      <TableCell>Client</TableCell>
                      <TableCell>Location</TableCell>
                      <TableCell>Daily Emails</TableCell>
                      <TableCell>Escalated Email : High</TableCell>
                      <TableCell>Escalated Email : Normal</TableCell>
                      <TableCell>Monthly Client Dashboard Email</TableCell>
                      {/* <TableCell align='center'>Invoice Email</TableCell> */}
                      <TableCell>Camera online/offline Email</TableCell>
                      <TableCell>Contact Number</TableCell>
                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loading ? (
                      <TableRow>
                        <TableCell colSpan={6} align="center">
                          <Box display="flex" justifyContent="center" alignItems="center" width="100%" py={2}>
                            <CircularProgress />
                          </Box>
                        </TableCell>
                      </TableRow>
                    ) : clientsContactDetails.length > 0 ? (
                      clientsContactDetails.map((client, index) => (
                        <TableRow key={index}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell sx={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            maxWidth: 'auto'
                          }}>
                            {client.Name}
                          </TableCell>
                          <TableCell sx={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            maxWidth: 'auto'
                          }}>
                            {client.Location}
                          </TableCell>
                          <TableCell align='left'>
                            {client.ContactEmail ? (client.ContactEmail !== null &&
                              client.ContactEmail.split(",").map((val, index) => (
                                <Box key={index} display="flex" flexDirection="column" gap={1} textAlign="left">
                                  <Typography>{val}</Typography>
                                </Box>
                              ))
                            ) : 'N/A'}
                          </TableCell>
                          <TableCell align='left'>
                            {client.HighPriorityClientEmails ? client.HighPriorityClientEmails !== null &&
                              client.HighPriorityClientEmails.split(",").map((val, index) => (
                                <Box key={index} display="flex" flexDirection="column" gap={1} textAlign="left">
                                  <Typography>{val}</Typography>
                                </Box>
                              )) : 'N/A'}
                          </TableCell>
                          <TableCell align='left'>
                            {client.LowPriorityClientEmails ? client.LowPriorityClientEmails !== null &&
                              client.LowPriorityClientEmails.split(",").map((val, index) => (
                                <Box key={index} display="flex" flexDirection="column" gap={1} textAlign="left">
                                  <Typography>{val}</Typography>
                                </Box>
                              )) : 'N/A'}
                          </TableCell>

                          <TableCell align='left'>
                            {client.MonthlyClientDashboardEmails ? client.MonthlyClientDashboardEmails !== null &&
                              client.MonthlyClientDashboardEmails.split(",").map((val, index) => (
                                <Box key={index} display="flex" flexDirection="column" gap={1} textAlign="left">
                                  <Typography>{val}</Typography>
                                </Box>
                              )) : 'N/A'}
                          </TableCell>
                          {/* <TableCell align='center'>
                            {client.InvoiceEmails ? client.InvoiceEmails !== null &&
                              client.InvoiceEmails.split(",").map((val, index) => (
                                <Box key={index} display="flex" flexDirection="column" gap={1} textAlign="left">
                                  <Typography>{val}</Typography>
                                </Box>
                              )) : 'N/A'}
                          </TableCell> */}
                          <TableCell align='left'>
                            {client.CameraDownEmails ? client.CameraDownEmails && client.CameraDownEmails !== null &&
                              client.CameraDownEmails.split(",").map((val, index) => (
                                <Box key={index} display="flex" flexDirection="column" gap={1} textAlign="left">
                                  <Typography>{val}</Typography>
                                </Box>
                              )) : 'N/A'}
                          </TableCell>
                          <TableCell align='left'>
                            {/* {client.ContactMobileNo} */}
                            {client.ContactMobileNo ? client.ContactMobileNo && client.ContactMobileNo !== null &&
                              client.ContactMobileNo.split(",").map((val, index) => (
                                <Box key={index} display="flex" flexDirection="column" gap={1} textAlign="left">
                                  <Typography>{val}</Typography>
                                </Box>
                              )) : 'N/A'}
                          </TableCell>
                          <TableCell>
                            <Box sx={{ display: 'flex', gap: 1 }}>
                              <Button type="submit" variant="contained" onClick={() => handleEdit(client)}>
                                Edit
                              </Button>
                              <Button
                                color="error"
                                variant="contained"
                                onClick={() => handleDelete(client.Id)}
                              >
                                Delete
                              </Button>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (

                      <TableRow>
                        <TableCell colSpan={10} align="center">
                          <Box display="flex" justifyContent="center" alignItems="center" width="100%" py={2}>
                            <Typography sx={{ fontWeight: 'bold' }}>No Data</Typography>
                          </Box>
                        </TableCell>
                      </TableRow>

                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </CardContent>
        </Card>

        <Dialog open={editDialogOpen} onClose={handleCloseEditDialog}>
          <DialogTitle>{editClientName}</DialogTitle>
          <DialogContent>
            <Grid container spacing={2} sx={{ marginTop: 1 }}>
              <Grid item xs={18}>
                <InputLabel shrink>
                  Daily Emails
                </InputLabel>
                <Box
                  sx={{
                    border: (theme) => '1px solid ' + theme.palette.divider,
                    padding: '8px',
                    borderRadius: '8px',
                    minHeight: editedmail ? 'auto' : '50px',
                  }}
                  onClick={() => handleBoxClick('email')}
                >
                  {editedmail.split(',').map((email, index) => (
                    <Box
                      key={index}
                      sx={{
                        marginBottom: 1,
                        width: '60%',
                        backgroundColor: (theme) => theme.palette.action.selected,
                        position: 'relative',
                        borderRadius: '100px',
                        border: 'none',
                        borderColor: 'none'
                      }}
                    >
                      <TextField
                        //className={classes.root}
                        placeholder='Add Email'
                        //type='number'
                        value={email}
                        onClick={(e) => {
                          e.stopPropagation()
                        }}
                        onChange={(e) => handleNumberChange(e, index, 'email')}
                        fullWidth
                        size="small"
                        sx={{
                          '& input': {
                            height: '14px', 
                            fontSize: '14px',
                            color: (theme) => theme.palette.text.primary,
                            "&::placeholder": {
                              color: (theme) => theme.palette.text.secondary,
                              opacity: 1,
                            },
                          },
                          '& fieldset': {
                            border:'none'
                          },
                        }}
                      />
                      <Box
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          right: '8px',
                          transform: 'translateY(-50%)',
                          width: '15px',
                          height: '15px',
                          borderRadius: '50%',
                          backgroundColor: (theme) => theme.palette.action.selected,
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}>
                        <IconButton
                          onClick={(e) => removeNumber(e, index, 'email')}
                        >
                          <CloseIcon fontSize="small" sx={{ fontSize: '14px', color: 'text.secondary' }} />
                        </IconButton>
                      </Box>
                    </Box>

                  ))}

                </Box>


                {emailEditError && <Typography color="error" variant="body2" align="left" marginTop={1}>{emailEditError}</Typography>}
                {emptyEditFieldErrors.email && <Typography color="error" variant="body2" align="left" marginTop={1}>{emptyEditFieldErrors.email}</Typography>}
                {shouldShowPrompt('email', true) && (
                  <Typography color="error" variant="body2" align="left" marginTop={1}>
                    {emptyFieldPrompts.email}
                  </Typography>
                )}
              </Grid>

              <Grid item xs={18}>
                <InputLabel shrink>
                  Escalated Emails : High
                </InputLabel>
                <Box
                  sx={{
                    border: (theme) => '1px solid ' + theme.palette.divider,
                    padding: '8px',
                    borderRadius: '8px',
                    minHeight: editedHighEmail ? 'auto' : '50px',
                  }}
                  onClick={() => handleBoxClick('editedHighEmail')}
                >
                  {editedHighEmail.split(',').map((email, index) => (
                    <Box
                      key={index}
                      sx={{
                        marginBottom: 1,
                        width: '60%',
                        backgroundColor: (theme) => theme.palette.action.selected,
                        position: 'relative',
                        borderRadius: '100px',
                        border: 'none',
                        borderColor: 'none'
                      }}
                    >
                      <TextField
                        placeholder='Add High Priority Email'
                        value={email}
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                        onChange={(e) => handleNumberChange(e, index, 'editedHighEmail')}
                        fullWidth
                        size="small"
                        sx={{
                          '& input': {
                            height: '14px', 
                            fontSize: '14px',
                            color: (theme) => theme.palette.text.primary,
                            "&::placeholder": {
                              color: (theme) => theme.palette.text.secondary,
                              opacity: 1,
                            },
                          },
                          '& fieldset': {
                            border:'none'
                          },
                        }}
                      />
                      <Box
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          right: '8px',
                          transform: 'translateY(-50%)',
                          width: '15px',
                          height: '15px',
                          borderRadius: '50%',
                          backgroundColor: (theme) => theme.palette.action.selected,
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}>
                        <IconButton
                          onClick={(e) => removeNumber(e, index, 'editedHighEmail')}
                        >
                          <CloseIcon fontSize="small" sx={{ fontSize: '14px', color: 'text.secondary' }} />
                        </IconButton>
                      </Box>
                    </Box>
                  ))}

                </Box>
                {emailHighValidate && <Typography color="error" variant="body2" align="left" marginTop={1}>{emailHighValidate}</Typography>}
                {emptyEditFieldErrors.editedHighEmail && <Typography color="error" variant="body2" align="left" marginTop={1}>{emptyEditFieldErrors.editedHighEmail}</Typography>}
                {shouldShowPrompt('editedHighEmail', true) && (
                  <Typography color="error" variant="body2" align="left" marginTop={1}>
                    {emptyFieldPrompts.editedHighEmail}
                  </Typography>
                )}
              </Grid>



              <Grid item xs={18}>
                <InputLabel shrink>
                  Escalated Emails : Normal
                </InputLabel>
                <Box
                  sx={{
                    border: (theme) => '1px solid ' + theme.palette.divider,
                    padding: '8px',
                    borderRadius: '8px',
                    minHeight: editedNormalEmail ? 'auto' : '50px',
                  }}
                  onClick={() => handleBoxClick('editedNormalEmail')}
                >
                  {editedNormalEmail.split(',').map((email, index) => (
                    <Box
                      key={index}
                      sx={{
                        marginBottom: 1,
                        width: '60%',
                        backgroundColor: (theme) => theme.palette.action.selected,
                        position: 'relative',
                        borderRadius: '100px',
                        border: 'none',
                        borderColor: 'none'
                      }}
                    >
                      <TextField
                        placeholder='Add Normal Priority Email'
                        value={email}
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                        onChange={(e) => handleNumberChange(e, index, 'editedNormalEmail')}
                        fullWidth
                        size="small"
                        sx={{
                          '& input': {
                            height: '14px', 
                            fontSize: '14px',
                            color: (theme) => theme.palette.text.primary,
                            "&::placeholder": {
                              color: (theme) => theme.palette.text.secondary,
                              opacity: 1,
                            },
                          },
                          '& fieldset': {
                            border:'none'
                          },
                        }}
                      />
                      <Box
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          right: '8px',
                          transform: 'translateY(-50%)',
                          width: '15px',
                          height: '15px',
                          borderRadius: '50%',
                          backgroundColor: (theme) => theme.palette.action.selected,
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}>
                        <IconButton
                          onClick={(e) => removeNumber(e, index, 'editedNormalEmail')}
                        >
                          <CloseIcon fontSize="small" sx={{ fontSize: '14px', color: 'text.secondary' }} />
                        </IconButton>
                      </Box>
                    </Box>
                  ))}

                </Box>
                {emailNormalValidate && <Typography color="error" variant="body2" align="left" marginTop={1}>{emailNormalValidate}</Typography>}
                {emptyEditFieldErrors.editedNormalEmail && <Typography color="error" variant="body2" align="left" marginTop={1}>{emptyEditFieldErrors.editedNormalEmail}</Typography>}
                {shouldShowPrompt('editedNormalEmail', true) && (
                  <Typography color="error" variant="body2" align="left" marginTop={1}>
                    {emptyFieldPrompts.editedNormalEmail}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={18}>
                <InputLabel shrink>
                  Monthly Client Dashboard Email
                </InputLabel>
                <Box
                  sx={{
                    border: (theme) => '1px solid ' + theme.palette.divider,
                    padding: '8px',
                    borderRadius: '8px',
                    minHeight: editedMonthlyDashboardEmail ? 'auto' : '50px',
                  }}
                  onClick={() => handleBoxClick('editedMonthlyDashboardEmail')}
                >
                  {editedMonthlyDashboardEmail.split(',').map((email, index) => (
                    <Box
                      key={index}
                      sx={{
                        marginBottom: 1,
                        width: '60%',
                        backgroundColor: (theme) => theme.palette.action.selected,
                        position: 'relative',
                        borderRadius: '100px',
                        border: 'none',
                        borderColor: 'none'
                      }}
                    >
                      <TextField
                        placeholder='Add Monthly Client Dashboard Email'
                        value={email}
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                        onChange={(e) => handleNumberChange(e, index, 'editedMonthlyDashboardEmail')}
                        fullWidth
                        size="small"
                        sx={{
                          '& input': {
                            height: '14px', 
                            fontSize: '14px',
                            color: (theme) => theme.palette.text.primary,
                            "&::placeholder": {
                              color: (theme) => theme.palette.text.secondary,
                              opacity: 1,
                            },
                          },
                          '& fieldset': {
                            border:'none'
                          },
                        }}
                      />
                      <Box
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          right: '8px',
                          transform: 'translateY(-50%)',
                          width: '15px',
                          height: '15px',
                          borderRadius: '50%',
                          backgroundColor: (theme) => theme.palette.action.selected,
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}>
                        <IconButton
                          onClick={(e) => removeNumber(e, index, 'editedMonthlyDashboardEmail')}
                        >
                          <CloseIcon fontSize="small" style={{ fontSize: '14px', color: 'text.secondary' }} />
                        </IconButton>
                      </Box>
                    </Box>
                  ))}
                </Box>
                {monthlyClientErrorMessage && <Typography color="error" variant="body2" align="left" marginTop={1}>{monthlyClientErrorMessage}</Typography>}
                {emptyEditFieldErrors.editedMonthlyDashboardEmail && <Typography color="error" variant="body2" align="left" marginTop={1}>{emptyEditFieldErrors.editedMonthlyDashboardEmail}</Typography>}
                {shouldShowPrompt('editedMonthlyDashboardEmail', true) && (
                  <Typography color="error" variant="body2" align="left" marginTop={1}>
                    {emptyFieldPrompts.editedMonthlyDashboardEmail}
                  </Typography>
                )}
              </Grid>

              {/* <Grid item xs={18}>
                <InputLabel shrink>
                  Invoice Email
                </InputLabel>
                <Box
                  sx={{
                    border: '1px solid #b4b4b4',
                    padding: '8px',
                    borderRadius: '8px',
                    minHeight: editedInvoiceEmail ? 'auto' : '50px',
                  }}
                  onClick={() => handleBoxClick('editedInvoiceEmail')}
                >
                  {editedInvoiceEmail.split(',').map((email, index) => (
                    <Box
                      key={index}
                      sx={{
                        marginBottom: 1,
                        width: '60%',
                        backgroundColor: '#E8E8E8',
                        position: 'relative',
                        borderRadius: '100px',
                        border: 'none',
                        borderColor: 'none'
                      }}
                    >
                      <TextField
                        placeholder='Add Invoice Email'
                        value={email}
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                        onChange={(e) => handleNumberChange(e, index, 'editedInvoiceEmail')}
                        fullWidth
                        size="small"
                        sx={{
                          '& input': {
                            height: '14px',
                            fontSize: '14px',
                            color: '#000',
                            "&::placeholder": {
                              color: "#000",
                              opacity: 1,
                            },
                          },
                          '& fieldset': {
                            border: 'none'
                          },
                        }}
                      />
                      <Box
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          right: '8px',
                          transform: 'translateY(-50%)',
                          width: '15px',
                          height: '15px',
                          borderRadius: '50%',
                          backgroundColor: '#E8E8E8',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}>
                        <IconButton
                          onClick={(e) => removeNumber(e, index, 'editedInvoiceEmail')}
                        >
                          <CloseIcon fontSize="small" style={{ fontSize: '14px', color: '#000' }} />
                        </IconButton>
                      </Box>
                    </Box>
                  ))}
                </Box>
                {invoiceEmailErrorMessage && <Typography color="error" variant="body2" align="left" marginTop={1}>{invoiceEmailErrorMessage}</Typography>}
              </Grid> */}

              <Grid item xs={18}>
                <InputLabel shrink>
                  Camera online/offline Email
                </InputLabel>
                <Box
                  sx={{
                    border: (theme) => '1px solid ' + theme.palette.divider,
                    padding: '8px',
                    borderRadius: '8px',
                    minHeight: editedCameraDownEmail ? 'auto' : '50px',
                  }}
                  onClick={() => handleBoxClick('editedCameraDownEmail')}
                >
                  {editedCameraDownEmail.split(',').map((email, index) => (
                    <Box
                      key={index}
                      sx={{
                        marginBottom: 1,
                        width: '60%',
                        backgroundColor: (theme) => theme.palette.action.selected,
                        position: 'relative',
                        borderRadius: '100px',
                        border: 'none',
                        borderColor: 'none'
                      }}
                    >
                      <TextField
                        placeholder='Add Camera online/offline Email'
                        value={email}
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                        onChange={(e) => handleNumberChange(e, index, 'editedCameraDownEmail')}
                        fullWidth
                        size="small"
                        sx={{
                          '& input': {
                            height: '14px', 
                            fontSize: '14px',
                            color: (theme) => theme.palette.text.primary,
                            "&::placeholder": {
                              color: (theme) => theme.palette.text.secondary,
                              opacity: 1,
                            },
                          },
                          '& fieldset': {
                            border:'none'
                          },
                        }}
                      />
                      <Box
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          right: '8px',
                          transform: 'translateY(-50%)',
                          width: '15px',
                          height: '15px',
                          borderRadius: '50%',
                          backgroundColor: (theme) => theme.palette.action.selected,
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}>
                        <IconButton
                          onClick={(e) => removeNumber(e, index, 'editedCameraDownEmail')}
                        >
                          <CloseIcon fontSize="small" style={{ fontSize: '14px', color: 'text.secondary' }} />
                        </IconButton>
                      </Box>
                    </Box>
                  ))}

                </Box>
                {emailCameraValidate && <Typography color="error" variant="body2" align="left" marginTop={1}>{emailCameraValidate}</Typography>}
                {emptyEditFieldErrors.editedCameraDownEmail && <Typography color="error" variant="body2" align="left" marginTop={1}>{emptyEditFieldErrors.editedCameraDownEmail}</Typography>}
                {shouldShowPrompt('editedCameraDownEmail', true) && (
                  <Typography color="error" variant="body2" align="left" marginTop={1}>
                    {emptyFieldPrompts.editedCameraDownEmail}
                  </Typography>
                )}
              </Grid>

              <Grid item xs={18}>
                <InputLabel shrink>
                  Contact Number
                </InputLabel>
                <Box
                  sx={{
                    border: (theme) => '1px solid ' + theme.palette.divider,
                    padding: '8px',
                    borderRadius: '8px',
                    minHeight: contactNumber ? 'auto' : '50px',
                  }}
                  onClick={() => handleBoxClick('number')}
                >
                  {editedNumber.split(',').map((number, index) => (
                    <Box
                      key={index}
                      sx={{
                        marginBottom: 1,
                        width: '60%',
                        backgroundColor: (theme) => theme.palette.action.selected,
                        position: 'relative',
                        borderRadius: '100px',
                        border: 'none',
                        borderColor: 'none'
                      }}
                    >
                      <TextField
                        //className={classes.root}
                        placeholder='Add Contact Number'
                        type='number'
                        value={number}
                        onClick={(e) => {
                          e.stopPropagation()
                        }}
                        onChange={(e) => handleNumberChange(e, index, 'number')}
                        fullWidth
                        size="small"
                        sx={{
                          '& input': {
                            height: '14px', 
                            fontSize: '14px',
                            color: (theme) => theme.palette.text.primary,
                            "&::placeholder": {
                              color: (theme) => theme.palette.text.secondary,
                              opacity: 1,
                            },
                          },
                          '& fieldset': {
                            border:'none'
                          },
                        }}
                      />
                      <Box
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          right: '8px',
                          transform: 'translateY(-50%)',
                          width: '15px',
                          height: '15px',
                          borderRadius: '50%',
                          backgroundColor: (theme) => theme.palette.action.selected,
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}>
                        <IconButton
                          onClick={(e) => removeNumber(e, index, 'number')}
                        >
                          <CloseIcon fontSize="small" style={{ fontSize: '14px', color: 'text.secondary' }} />
                        </IconButton>
                      </Box>
                    </Box>

                  ))}

                </Box>
                {mobileEditError && <Typography color="error" variant="body2" align="left" marginTop={1}>{mobileEditError}</Typography>}
                {emptyEditFieldErrors.number && <Typography color="error" variant="body2" align="left" marginTop={1}>{emptyEditFieldErrors.number}</Typography>}
                {shouldShowPrompt('number', true) && (
                  <Typography color="error" variant="body2" align="left" marginTop={1}>
                    {emptyFieldPrompts.number}
                  </Typography>
                )}
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button color="error" variant="contained" onClick={handleCloseEditDialog}>Cancel</Button>
            <Button onClick={handleSaveEditDialog} color="primary" variant="contained">Save</Button>
          </DialogActions>
        </Dialog>

        <Dialog open={display} onClose={handleDisplay}>
          <DialogContent>
            Do You Want to Delete Contact?
          </DialogContent>
          <DialogActions>
            <Button onClick={() => {
              setDisplay(false)
              setClientId('')
            }} color="error" variant="contained">
              Cancel
            </Button>
            <Button onClick={delContact} color="primary" variant="contained">Ok</Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Page>
    </>
  );
};

export default EmailReports;
